// Extra strings for TurnosIA module and sidebar items — Italian translation
const messages = {
  it: {
    translations: {
      // feat_315 — formato fecha/hora tipo WhatsApp (fmtSmartTimestamp)
      smartTimestamp: {
        yesterday: "Ieri",
        today: "Oggi",
      },
      loginPage: {
        sections: {
          waia: {
            nav: "WAIA",
            title: "Che gestire WhatsApp non ti mangi più la giornata",
            chip1: "Casella condivisa",
            chip2: "IA che risponde",
            chip3: "Multi-azienda",
          },
          turnosia: {
            nav: "TurnosIA",
            title: "Appuntamenti su WhatsApp, senza assenze",
            chip1: "Lista d'attesa IA",
            chip2: "Promemoria",
            chip3: "Schermo sala d'attesa",
          },
          integraciones: {
            nav: "Integrazioni",
            title: "Collega i tuoi strumenti",
            chip1: "Google Sheets",
            chip2: "CRM",
            chip3: "Webhooks · n8n",
            chip4: "API propria",
          },
        },
        metaBadge: "Fornitore di tecnologia verificato — Meta",
      },
      turnosChat: {
        iaPaused: "IA in pausa",
        keepAttending: "Continua a rispondere",
        closeDialogTitle: "Chiudi chat appuntamenti",
        closeDialogBody: "Vuoi restituire la conversazione all'IA o lasciarla in gestione umana?",
        returnToIa: "Sì, restituisci all'IA",
        keepHuman: "Lascia in gestione umana",
        continueAttending: "Continua a rispondere",
        iaResumed: "L'IA ha ripreso la conversazione",
        badgeActive: "TurnosIA",
        sessionError: "Impossibile gestire la sessione appuntamenti",
      },
      floatingChat: {
        resize: "Ridimensiona",
        minimize: "Riduci a icona",
        close: "Chiudi",
        openFloating: "Apri in finestra fluttuante",
        errorOpening: "Impossibile aprire la chat",
        loadError: "Non è stato possibile caricare questa conversazione.",
        loadErrorDenied: "Non hai il permesso di aprire questa chat (il ticket non è in nessuna delle tue code).",
        retry: "Riprova",
        loading: "Caricamento conversazione…",
        via: "via",
        lineNotAllowed:
          "Impossibile aprire la chat su quella linea (non appartiene alla tua azienda o non esiste).",
      },
      templateOverrides: {
        loading: "Caricamento modelli…",
        sectionTitle: "Modello Meta per messaggio (fuori dalle 24 h)",
        qrLine: "La linea di TurnosIA è QR (testo libero): non usa modelli Meta.",
        noLine: "Questa azienda non ha una linea Meta di TurnosIA configurata.",
        intro:
          "Scegli quale modello Meta approvato usa ogni messaggio fuori dalla finestra di 24 h. Vengono offerti solo quelli compatibili nelle variabili. Nessuna scelta = il modello predefinito.",
        vars: "variabili",
        useDefault: "Usa quello predefinito",
        incompatible: "incompatibile",
        backToDefault: "Torna al predefinito",
        mapped: "Mappato su",
        usingConvention: "Usa il predefinito",
        marketingWarning:
          "È un modello MARKETING in un messaggio transazionale: Meta può bloccarlo o il cliente segnalarlo come spam.",
        noneCompatible:
          "Non ci sono modelli approvati compatibili (stesso numero di variabili) per questo messaggio.",
        saveError: "Impossibile salvare la mappatura.",
        useLabel: "Fuori dalle 24 h, usa:",
        metaSubsectionTitle: "Fuori dalle 24 h (modello Meta)",
        notCreated: "non ancora creato/approvato in Meta",
        noPreview: "Nessuna anteprima per questo modello.",
        noMeta: "Questo messaggio esce sempre come testo libero nella conversazione (senza modello Meta).",
        stApproved: "Approvato",
        stPending: "In revisione",
        stRejected: "Rifiutato",
        showExample: "Mostra con dati di esempio",
        hideExample: "Mostra con nomi di variabile",
        reminderFuture: "Con anticipo (più di 12 h prima)",
        reminderToday: "Il giorno dell'appuntamento (12 h o meno)",
      },
      panel: {
        title: "Pannello generale",
        refresh: "Aggiorna",
        summary: {
          messages2h: "Messaggi 2h",
          openTickets: "Ticket aperti",
          activeCompanies: "Aziende attive",
          usersOnline: "Utenti online",
          totalCompanies: "Aziende totali",
        },
        system: {
          disk: "Disco",
          mem: "Memoria",
          load: "Carico",
          public: "Media",
          uptime: "Uptime",
          error: "errore di misura",
        },
        companies: "Aziende",
        search: "Cerca per nome, slug, ID, utente, email o note…",
        filterAll: "Tutte",
        col: {
          id: "ID",
          name: "Nome",
          status: "Stato",
          usersOnline: "Online",
          whatsapp: "WA",
          messages7d: "Msg 7g",
          actions: "Azioni",
        },
        actions: {
          edit: "Modifica",
          impersonate: "Entra come",
          clear: "Pulisci dati",
          create: "Crea azienda",
          advanced: "Configurazione avanzata",
          users: "Gestisci utenti",
          viewAsAdmin: "Entra come admin",
          viewAsUser: "Entra come utente specifico",
        },
        notesLabel: "Note (solo superadmin)",
        editTitle: "Modifica azienda",
        createTitle: "Crea azienda",
        adminSection: "Utente amministratore iniziale (opzionale)",
        selfRegistration: "Consenti registrazione aziende (signup pubblico)",
        online: "Online",
      },
      operationStatus: {
        active: "Attiva",
        paused: "In pausa",
        blocked: "Bloccata",
        waiting_meta: "In attesa di Meta",
        demo: "Demo",
        trial: "Prova",
      },
      aiAssistantStats: {
        menu: "Statistiche IA",
        tooltips: {
          horasAhorradas:
            "Stima del tempo di assistenza che l'IA ha risparmiato al team. Si calcola in base al numero di conversazioni e a un tempo stimato di gestione per conversazione. È un valore stimato, lo affineremo nel tempo.",
          cobertura:
            "Percentuale di risposte fornite dall'IA fuori dall'orario di assistenza umana —di notte o nel weekend—, quando una persona non avrebbe risposto sul momento. Si misura sulle conversazioni a cui è stata data risposta.",
          reclamosATiempo:
            "Numero di reclami che l'IA ha rilevato e segnalato lo stesso giorno, in tempo perché il team potesse intervenire.",
          iaVsHumano:
            "Messaggi a cui ha risposto l'IA rispetto a quelli a cui ha risposto una persona, nel periodo.",
          tasaRespuesta:
            "Delle conversazioni avviate dall'IA, quale percentuale ha ricevuto risposta dal cliente. È risposte diviso conversazioni inviate.",
          tasaAccion:
            "Dei clienti che hanno risposto, in quale percentuale l'IA è arrivata a una conclusione —soddisfatto o reclamo—. Si misura su chi ha risposto.",
          satisfechos:
            "Clienti rimasti soddisfatti. La prima percentuale è su tutte le conversazioni inviate; la seconda, solo su quelle a cui è stata data risposta.",
          reclamos:
            "Clienti che hanno espresso un reclamo o un'insoddisfazione. La prima percentuale è sul totale inviato; la seconda, solo su chi ha risposto.",
          sinRespuesta:
            "Clienti che non hanno risposto al sondaggio. La prima percentuale è sul totale inviato; la seconda, su chi ha risposto.",
          embudo:
            "Percorso delle conversazioni: quante sono state inviate, quante hanno risposto e quante sono arrivate a una conclusione.",
          primeraRespuesta:
            "Tempo medio impiegato dal cliente per rispondere al primo messaggio dell'IA.",
          atencionHumana:
            "Indica se una persona del team è intervenuta nella chat durante l'orario di assistenza.",
          objetoReclamo:
            "Argomento principale di ogni reclamo, identificato dall'IA alla chiusura della conversazione.",
          etiquetas:
            "Etichette di interesse —ad esempio, interesse all'acquisto— che l'IA ha segnato nelle conversazioni.",
          breakdowns:
            "Gli stessi risultati suddivisi per filiale e per tipo di sondaggio, per confrontarli.",
          canalVenta:
            "Canale di vendita: P = Convenzionale, PA = Piano di risparmio. Il dato è disponibile nelle vendite dal 24/06/2026.",
        },
        heroTitle: "Statistiche per assistente IA",
        detailTitle: "Dettaglio dell'assistente",
        backToHero: "Torna al riepilogo",
        disabled: "Il modulo statistiche non è abilitato per la tua azienda.",
        modeTV: "Modalità TV",
        exitTV: "Esci",
        clientSummary: "Riepilogo cliente",
        selectAssistant: "Vedi assistente",
        breakdowns: {
          title: "Dettaglio per segmento",
          bySucursal: "Per filiale",
          byTipoEncuesta: "Per tipo sondaggio",
          bySubtipo: "Per sottotipo",
        },
        canalVenta: {
          title: "Canale di vendita",
          filterLabel: "Canale di vendita",
          all: "Tutti",
          convencional: "Convenzionale",
          planAhorro: "Piano di risparmio",
          sinDato: "Senza dato",
          availabilityNote:
            "Dato disponibile dal 24/06/2026 · vendite precedenti non registrate.",
          tooltip:
            "Canale di vendita: P = Convenzionale, PA = Piano di risparmio. Disponibile nelle vendite dal 24/06/2026.",
        },
        cards: {
          horasAhorradas: "Ore risparmiate",
          horasAhorradasCaption: "{{name}} ti ha fatto risparmiare {{n}} ore",
          cobertura: "Copertura 24/7",
          coberturaCaption: "{{pct}} gestito fuori orario, 0 in attesa di un umano",
          reclamos: "Reclami in tempo",
          reclamosCaption: "{{n}} reclami rilevati in tempo",
          iaVsHumano: "IA vs umano",
          iaVsHumanoCaption: "{{ia}} IA / {{hum}} umano",
        },
        table: {
          asistente: "Assistente",
          tipo: "Tipo",
          enviados: "Inviati",
          respondieron: "Hanno risposto",
          tasaResp: "Tasso risp.",
          reclamos: "Reclami",
        },
        filters: {
          dateRange: "Intervallo di date",
          from: "Da",
          to: "A",
          sucursal: "Filiale",
          tipoEncuesta: "Tipo di sondaggio",
          all: "Tutte",
          service: "Service",
          venta: "Vendita",
        },
        funnel: {
          title: "Imbuto",
          enviados: "Inviati",
          respondieron: "Hanno risposto",
          clasificados: "Classificati",
        },
        kpis: {
          title: "Indicatori",
          satisfechos: "Soddisfatti",
          reclamos: "Reclami",
          sinRespuesta: "Senza risposta",
          sobreTotal: "sul totale",
          sobreRespondieron: "su chi ha risposto",
          tasaRespuesta: "Tasso di risposta",
          tasaAccion: "Tasso di azione di Sofía",
          objetoReclamo: "Oggetto del reclamo",
          tagsTrackeados: "Etichette monitorate",
          interesadoComprar: "Interessato all'acquisto",
          primeraRespuesta: "1ª risposta del cliente",
          atencionHumana: "Assistenza umana in orario",
          atendidoHorario: "Gestito in orario",
          atendidoCierre: "Gestito a fine giornata",
          si: "Sì",
          no: "No",
        },
        insights: {
          title: "Raccomandazioni",
          recommendations: "{{count}} raccomandazione",
          recommendations_plural: "{{count}} raccomandazioni",
          severityWarning: "Avviso",
          severityInfo: "Info",
          severitySuccess: "Risultato",
          severityOportunidad: "Opportunità",
          severitySofiaEnAccion: "Sofía in azione",
          ventana_muerta:
            "Sofía risponde a qualsiasi ora. {{count}} sondaggi sono partiti dopo le {{horaLimiteDisparo}}; poiché l'avviso al team scatta solo {{timeoutHours}}h più tardi, i pochi che non rispondono non fanno in tempo a passare a una persona prima della chiusura. Inviandoli prima si recupera quel margine.",
          disparo_tardio:
            "Sofía invia i sondaggi intorno alle {{medianaHoraDisparo}}. Anticipando l'invio, più clienti che non rispondono fanno in tempo a passare al team prima della chiusura.",
          timeout_absorbe:
            "Il {{pct}} non ha risposto entro la finestra. Sofía è rimasta comunque disponibile per quando vorranno riprendere.",
          reclamo_sin_atencion:
            "Sofía ha rilevato e segnalato {{count}} reclami lo stesso giorno. Per chiudere il cerchio, conviene che una persona li prenda in carico prima della chiusura.",
          buena_cobertura:
            "Sofía ha risposto a {{fueraHorarioCount}} sondaggi fuori orario — assistenza che un umano non avrebbe dato.",
          generic: "Raccomandazione disponibile.",
        },
        units: {
          horas: "h",
          seg: "s",
          min: "min",
        },
        empty: {
          noData: "Ancora nessun dato per questo periodo.",
          noAssistants: "Questo cliente non ha ancora assistenti con statistiche.",
          noObjeto: "Nessun oggetto di reclamo in questo periodo.",
          noTags: "Nessuna etichetta monitorata in questo periodo.",
          noPeriod: "Nessun dato in questo periodo.",
        },
      },
      chatInput: {
        systemChannelReadOnly: "Canale di avvisi automatici. Non è possibile inviare messaggi.",
      },
      matchpropBanner: {
        text: "Hai {{count}} corrispondenza/e di immobili da rivedere in MatchProp",
        goToChat: "Vai alla chat Avvisi Immobili",
      },
      chatHighlight: {
        needsAttention: "Richiede attenzione",
        matchprop: "Corrispondenza immobiliare",
      },
      matchpropCard: {
        title: "Corrispondenza rilevata",
        test: "PROVA",
        levelExact: "ESATTO",
        levelSimilar: "SIMILE",
        requestLabel: "Richiesta",
        inGroup: "nel gruppo {{group}}",
        operacion: "Operazione",
        tipo: "Tipo",
        dorms: "Cam.",
        zonas: "Zone",
        precioMax: "Prezzo max.",
        matchesHeader: "Corrispondenze",
        priceOnRequest: "prezzo su richiesta",
        viewListing: "Vedi scheda",
        contactAuthor: "Scrivi a {{name}}",
        contactAuthorShort: "Scrivi al collega",
        viewInGroup: "Vedi richiesta nel gruppo",
        contactOk: "Chat del collega aperta",
        groupNotFound: "Chat del gruppo non trovata",
        actionError: "Impossibile completare l'azione",
      },
      turnosIA: {
        setupHealth: {
          titulo: "Questa azienda non ha completato l'attivazione di TurnosIA",
          token: {
            queFalta: "L'azienda non ha il token di WAIA configurato.",
            comoResolver: "Viene copiato da solo attivando il modulo TurnosIA da WAIA: spegni e riaccendi quello switch.",
          },
          rubro: {
            queFalta: "All'azienda non è stato applicato nessun settore.",
            comoResolver: "Dal pannello superadmin di TurnosIA scegli il modello di settore: crea specialità, campi e il vocabolario dell'attività.",
          },
          especialidades: {
            queFalta: "Non c'è nessuna specialità caricata, quindi non si può creare un professionista.",
            comoResolver: "Applica un modello di settore (le crea) oppure caricale a mano da Servizi.",
          },
        },
        bandeja: {
          tituloTarjeta: "Casi da risolvere",
          tituloInbox: "Casi da gestire",
          sinCasos: "Nessun caso in sospeso. L'IA sta gestendo tutto da sola. 🎉",
          sinNombre: "Senza nome",
          enCurso: "In corso",
          tomar: "Prendi in carico",
          resuelto: "Risolto",
          resolverTurno: "Prenota",
          asignarTurno: "Assegna {{appointment}}",
          verTurno: "Vedi {{appointment}}",
          notasTurno: "Note {{delAppointment}}",
          abrirChat: "Apri chat",
          sinTelefonoValido: "Nessun telefono valido",
          chatNoEncontrado: "Nessuna chat aperta trovata per questo contatto.",
          tomadoOk: "Caso preso in carico",
          resueltoOk: "Caso risolto",
          errorGuardar: "Impossibile aggiornare il caso",
          turnoCreadoHint: "Fatto, è stato prenotato. Se il caso è risolto, segnalo come Risolto.",
          turnoRelacionado: "{{appointment_c}} collegato",
          motivo: "Motivo",
          horaCaso: "Ora",
          transcriptNoDisponible: "Il dettaglio della conversazione non è disponibile in questa vista.",
          conversacion: "Conversazione",
          reason: {
            fuera_de_alcance: "Fuori ambito",
            pidio_humano: "Ha chiesto un operatore",
            sin_disponibilidad: "Nessuna disponibilità",
            reclamo: "Reclamo",
            urgente: "Urgente",
            fallo_tecnico: "Guasto tecnico",
            otro: "Altro",
          },
        },
        vocabDefaults: {
          patient: "paziente", patientPlural: "pazienti",
          patientName: "Nome del paziente", patientPhone: "Telefono",
          professional: "professionista", professionalPlural: "professionisti",
          appointment: "appuntamento", appointmentPlural: "appuntamenti",
          specialty: "specialità", specialtyPlural: "specialità",
          service: "servizio", servicePlural: "servizi",
          waitingRoom: "sala d'attesa", waitingRoomPlural: "sale d'attesa",
          cobertura: "copertura", coberturaPlural: "coperture",
          scheduler: "segretario", schedulerPlural: "segretari",
          room: "studio", roomPlural: "studi",
          patientGen: "m", professionalGen: "m", appointmentGen: "m", specialtyGen: "f",
          serviceGen: "m", waitingRoomGen: "f", coberturaGen: "f", schedulerGen: "m", roomGen: "m",
        },
        metricas: {
          widget: {
            verMas: "Vedi altro",
            verMasTooltip: "Vedi la pagina completa delle metriche",
            tooltip: "Cosa ha fatto l'assistente per la tua attività",
            vacio: "Qui vedrai cosa fa l'assistente per te: {{appointmentPlural}} che prenota da solo e {{appointmentPlural}} che recupera quando qualcuno annulla. Ancora nessuna attività da mostrare.",
            mes: "Dall'inizio del mese",
            d30: "Ultimi 30 giorni",
            agendadosSolos: "{{appointmentPlural}} prenotati da solo",
            seAgendaronSolos: "prenotati da solo",
            de: "su",
            recuperados: "recuperati",
            previos: "30 giorni precedenti: {{n}}",
          },
          filtroProfesional: "{{professional_c}}",
          filtroServicio: "{{service_c}}",
          sinFiltro: "Senza filtro",
          errorCarga: "Impossibile caricare le metriche. Riprova tra poco.",
          d7: "7 giorni", d30: "30 giorni", d90: "90 giorni", m12: "12 mesi",
          aTitulo: "Cosa ha fatto l'assistente per la tua attività",
          aSub: "Il ritorno dell'assistente nel periodo scelto.",
          aVacio: "Qui vedrai cosa fa l'assistente per te: {{appointmentPlural}} che prenota da solo, {{appointmentPlural}} che recupera quando qualcuno annulla, e le richieste che passa a una persona. Ancora nessuna attività da mostrare.",
          aAgendadosSolos: "{{appointmentPlural_c}} prenotati da solo",
          aRecuperados: "recuperati dal riequilibrio",
          aDerivados: "passati a una persona",
          aCreadosTotal: "{{appointmentPlural}} in totale",
          aCreadosRecuperados: "recuperati",
          aCreadosIA: "prenotati dall'IA",
          aCreadosMano: "inseriti a mano",
          aSerieRecuperados: "Recuperati",
          aNotaDesde: "Ciò che ha prenotato l'assistente si conta dal {{fecha}} (da quando registra la propria origine). Prima di quella data non si mostra, per non confondere con degli zeri.",
          bTitulo: "Salute dell'agenda",
          bSub: "Come è andato il periodo.",
          bVacio: "Quando ci sarà movimento nel periodo vedrai qui quanti sono stati completati, quanti annullati (e con quanto anticipo) e quanti non si sono presentati.",
          bCompletados: "Completati",
          bCancelados: "Annullati",
          bNoShow: "Non presentati",
          bAnticipacion: "Anticipo nell'annullare",
          bAnticipacionSub: "media · {{n}} annullamenti",
          bAnticipacionVacio: "nessun annullamento con data",
          bTasaConfirmacion: "Tasso di conferma",
          bTasaSub: "{{r}}/{{s}} hanno risposto · {{elPatient}}, non il pannello",
          bTasaVacio: "nessun promemoria di conferma nel periodo",
          cTitulo: "Qualità del servizio",
          cSub: "Puntualità, attesa e durata reale. Si calcola quando il team segna arrivo / chiamata / inizio / fine.",
          cVacio: "Quando il team userà il flusso di accoglienza (segnare che è arrivato, che è stato chiamato e quando è iniziato e finito) vedrai qui la puntualità, quanto si attende e la durata reale.",
          cPuntualidad: "Puntualità (ritardo medio all'inizio)",
          cPuntualidadSub: "{{pct}}% in orario · {{n}} serviti",
          cEspera: "Attesa media",
          cEsperaSub: "{{n}} con ora di arrivo",
          cEsperaVacio: "nessuna registrazione di arrivo",
          cDuracion: "Durata reale (media)",
          cDuracionSub: "stimato {{est}} min · {{n}} serviti",
          cSinDatos: "ancora nessun dato",
          dTitulo: "Attività dell'assistente",
          dSub: "Passaggi a una persona e promemoria inviati.",
          dVacio: "Qui vedrai per quali motivi l'assistente ha passato le richieste a una persona e quanti promemoria ha inviato. Ancora nessuna attività nel periodo.",
          dMotivos: "Motivi del passaggio ({{n}})",
          dSinDerivaciones: "Nessun passaggio nel periodo.",
          dRecordatorios: "Promemoria inviati ({{s}} di {{t}})",
          dSinRecordatorios: "Nessun promemoria nel periodo.",
          dDerivaciones: "Passaggi",
          dEnviados: "Inviati",
          dFallidos: "Falliti",
          pie: "Periodo {{from}} → {{to}}. I numeri provengono dal sistema e sono verificabili; le metriche che oggi non si possono calcolare con affidabilità non vengono mostrate.",
          rConfirmacionReserva: "Conferma di prenotazione",
          rRecordatorio: "Promemoria",
          rPedidoConfirmacion: "Richiesta di conferma",
          rOfertaLiberado: "Offerta di posto liberato",
          rOfertaListaEspera: "Offerta da lista d'attesa",
        },
        menu: {
          metricas: "Metriche",
          agenda: "Agenda",
          profesionales: "Professionisti",
          agendadores: "Segretari",
          servicios: "Servizi",
          disponibilidad: "Disponibilità",
          precios: "Prezzi",
          listaEspera: "Lista d'attesa",
          recordatorios: "Promemoria",
          ajustes: "Impostazioni",
          miAgenda: "La Mia Agenda",
        },
        calendar: {
          title: "Calendario",
          day: "Giorno",
          week: "Settimana",
          month: "Mese",
          today: "Oggi",
          prev: "Precedente",
          next: "Successivo",
          noEvents: "Nessun dato: non ci sono {{appointmentPlural}} in questo intervallo.",
          colorByProfessional: "Colore per {{professional}}",
          colorByStatus: "Colore per stato",
          allProfessionals: "Senza filtro",
          allAssigned: "Senza filtro (solo assegnati)",
          outOfHours: "Fuori dall'orario disponibile",
          movePast: "Non si può spostare nulla nel passato",
          moveConfirmTitle: "Riprogrammare",
          moveConfirmText: "Spostare {{name}} dal {{oldDateTime}} al {{newDateTime}}? Lo avvisiamo via WhatsApp.",
          moveCancelar: "Annulla",
          moveConfirmar: "Conferma",
          moveSuccess: "Fatto, è stato riprogrammato",
          moveErrorGeneric: "Impossibile spostare",
          moveOccupied: "L'orario è già occupato",
          moveNoPermission: "Non hai il permesso di spostare {{appointmentPlural}}",
          moveDiscarded: "Non è stato possibile rilasciarlo lì. Riprova rilasciandolo sul giorno e sull'ora che vuoi.",
          refresh: "Aggiorna",
        },
        tabs: {
          agendaDesc: "La giornata di oggi, organizzata per chi riceve. Puoi chiamare il prossimo e inviargli un promemoria.",
          profesionalesDesc: "Gestisci chi riceve {{appointmentPlural}}. Puoi aggiungere, modificare o disattivare.",
          agendadoresDesc: "Chi carica {{appointmentPlural}} a mano e può abilitare gli extra. Puoi aggiungere, modificare o disattivare.",
          serviciosDesc: "Configura cosa si offre, quanto dura e chi lo esegue.",
          disponibilidadDesc: "Configura gli orari di disponibilità e i blocchi dell'agenda, uno per uno.",
          preciosDesc: "Il listino prezzi dell'azienda. Si carica da un file e si può correggere a mano.",
          listaEsperaDesc: "Chi è in attesa di un posto e lo storico dei riequilibri automatici.",
          recordatoriosDesc: "Storico dei messaggi inviati e programmati.",
          ajustesDesc: "Configurazione dell'integrazione, promemoria e modelli di messaggi.",
        },
        status: {
          available: "Disponibile",
          reserved: "Riservato",
          completed: "Completato",
          cancelled: "Annullato",
          pending: "In attesa",
          confirmed: "Confermato",
          in_progress: "In corso",
          arrived: "In sala",
          called: "Chiamato",
          no_show: "Assente",
        },
        panel: {
          servicio: "Servizio",
          profesional: "Professionista",
          fechaHora: "Data e ora",
          consultorio: "Ambulatorio",
          telefono: "Telefono",
          sobreturno: "Appuntamento extra",
          cambiarEstado: "Cambia stato",
          estadoActualizado: "Stato aggiornato",
          estadoError: "Impossibile cambiare lo stato",
          notas: "Note",
          acciones: "Azioni",
          historial: "Storico",
          proximamente: "Prossimamente",
          cerrar: "Chiudi",
          notasVacio: "Ancora nessuna nota",
          notaPlaceholder: "Aggiungi una nota...",
          notaAgregar: "Aggiungi",
          notaCreada: "Nota aggiunta",
          notaError: "Impossibile aggiungere la nota",
          cancelarConMotivo: "Annulla con motivo",
          cancelarMotivoLabel: "Motivo",
          cancelarTitulo: "Annulla",
          cancelarOk: "Annullato, avvisato via WhatsApp",
          cancelarError: "Impossibile annullare",
          eliminar: "Elimina",
          eliminarTitulo: "Elimina",
          eliminarTexto: "Viene rimosso dall'agenda, ma resta nello storico.",
          eliminarMotivoLabel: "Motivo (facoltativo)",
          eliminarOk: "Eliminato",
          eliminarError: "Impossibile eliminare",
          reAvisarBtn: "Riavvisa",
          reAvisarOk: "Avviso inviato",
          reAvisarError: "Impossibile reinviare l'avviso",
          llamarBtn: "Chiama",
          llamarOk: "Passato a in corso",
          llamarError: "Impossibile chiamare",
          abrirChatBtn: "Apri chat",
          sinConversacion: "Nessuna conversazione",
          sinTelefonoValido: "Nessun telefono valido",
          dialogCancelar: "Annulla",
          dialogConfirmar: "Conferma",
          reprogramar: "Riprogramma",
          reprogramarTitulo: "Riprogramma",
          reprogramarFecha: "Nuova data",
          reprogramarHorario: "Orario disponibile",
          reprogramarSinSlots: "Nessun orario disponibile quel giorno",
          reprogramarConfirmar: "Riprogramma",
          reprogramarAviso: "Lo avvisiamo via WhatsApp.",
          reprogramarOk: "Riprogrammato, avvisato via WhatsApp",
          reprogramarError: "Impossibile riprogrammare",
          score: {
            cancelo: "Ha annullato",
            ausente: "Assente",
            clienteRiesgo: "{{patient_c}} a rischio",
          },
        },
        overtime: {
          configurar: "Configura sovraccarico",
          finDelDia: "Sovraccarico a fine giornata",
          entreTurnos: "Extra intercalato",
          maxSobreturnos: "Max. sovraccarichi al giorno",
          guardar: "Salva",
          guardado: "Configurazione salvata",
          cancelar: "Annulla",
          yaHayTurno: "C'è già qualcosa con {{name}} a quell'ora",
          badge: "Sovraccarico",
          cargarSobreturno: "Carica sovraccarico",
          activarHint: "Attiva il sovraccarico di oggi per poterne caricare uno",
          sinDisponibles: "Nessun sovraccarico disponibile",
        },
        atencion: {
          llego: "Arrivato",
          llegoTooltip: "Segna che il cliente è già qui. Evita il messaggio «stai arrivando?»",
          llegoOk: "{{nombre}}: arrivo registrato",
          llegoError: "Impossibile registrare l'arrivo",
          llamar: "Chiama",
          llamarError: "Impossibile chiamare",
          comenzarAtencion: "Inizia visita",
          comenzarError: "Non è stato possibile iniziare la visita",
          rellamar: "Richiama",
          rellamarOk: "Avviso reinviato",
          rellamarError: "Non è stato possibile reinviare l'avviso",
          cancelarAusente: "Annulla (assente)",
          confirmarAusenteTitulo: "Segnare come assente?",
          confirmarAusenteTexto: "Il posto si libera e resta registrato come assente.",
          ausenteOk: "Segnato come assente",
          ausenteError: "Non è stato possibile segnare come assente",
          enAtencion: "In visita",
          terminarAtencion: "Termina visita",
          terminarError: "Non è stato possibile terminare la visita",
          horaObjetivo: "Orario previsto di chiusura",
          enMin: "tra ~{{min}} min",
          etaTooltip: "Orario stimato di visita (si ricalcola)",
          avisoSonoroOn: "Avviso sonoro attivato",
          avisoSonoroOff: "Avviso sonoro disattivato",
          nudgeSobreturno: "Sei in anticipo — aggiungere un extra?",
          ahora: "Ora",
          diaEnHora: "In orario",
          diaAtrasado: "In ritardo +{{min}}min",
          diaAdelantado: "In anticipo −{{min}}min",
          sugerido: "Suggerito",
          fichaTitulo: "Chiamato",
          fichaServicio: "Servizio",
          fichaTelefono: "Telefono",
          minAbrev: "min",
        },
        header: {
          servicioActivo: "Servizio attivo",
          servicioNoDisponible: "Servizio non disponibile",
          title: "TurnosIA — {{appointmentPlural_c}}",
          noAcceso: "Non hai accesso a questo modulo.",
          contactarAdmin: "Contatta l'amministratore per abilitarlo.",
          volver: "Torna",
          backendNoResponde: "Il backend di TurnosIA non risponde.",
        },
        agendaHoy: "Agenda di oggi",
        turnosHoy: "Appuntamenti di oggi",
        proximosTurnos: "A seguire",
        sobretornosHoy: "Appuntamenti extra abilitati",
        sinTurnosHoy: "Niente per oggi",
        sinTurnosProximos: "Nessun appuntamento in programma.",
        sinTurnosPropios: "Non hai nulla in programma.",
        noTurnosHoy: "Non hai nulla per oggi.",
        vasAdelantado: "Sei in anticipo sull'agenda. Puoi abilitare un extra per oggi.",
        profesionalAdelantado: "Si è in anticipo sull'agenda. Puoi abilitare un extra per oggi.",
        misBloques: "I Miei Blocchi Speciali",
        sinSlots14Dias: "Nessuno slot nei prossimi 14 giorni.",
        slotsEspecialesHoy: "Slot speciali di oggi",
        libresCount: "{{count}} liberi",
        reservadosCount: "{{count}} riservati",
        adelantado: "in anticipo",
        atrasado: "in ritardo",
        ignorar: "Ignora",
        tabAgenda: "Agenda",
        tabMisBloques: "I Miei Blocchi",
        profesional: "Professionista",
        alertasTurnosEspeciales: "{{count}} avviso{{plural}} di blocchi speciali",
        importTurnos: {
          boton: "Carica Excel",
          historialBoton: "Caricamenti da Excel",
          titulo: "Caricamento di {{appointmentPlural}} da Excel",
          tabCargar: "Carica file",
          tabHistorial: "Cronologia",
          intro: "Carica l'elenco del sistema precedente. Prima vedrai cosa cambia; non si salva nulla finché non confermi.",
          elegirArchivo: "Scegli il file (.xls o .xlsx)",
          verConfig: "Impostazioni del caricamento",
          ocultarConfig: "Nascondi impostazioni",
          servicioDefault: "Servizio con cui vengono caricati",
          servicioDefaultAyuda: "Il file non indica il servizio: vengono caricati tutti con questo.",
          sinServicio: "Non configurato",
          recordatoriosDefault: "I nuovi caricamenti ricevono i promemoria programmati",
          configGuardada: "Impostazioni salvate",
          errorConfig: "Impossibile salvare le impostazioni",
          errorLeer: "Impossibile leggere il file",
          errorImportar: "Impossibile completare il caricamento",
          errorRevertir: "Impossibile annullare il caricamento",
          noSePuedeImportar: "Il file ha dei problemi e non può essere caricato:",
          radio: "Se ne creano {{crear}} e se ne annullano {{cancelar}}. Nessun messaggio viene inviato ora.",
          radioRecordatorios: "Vengono programmati {{n}} promemoria.",
          radioSinRecordatorios: "Questi {{appointmentPlural}} non riceveranno promemoria.",
          radioInmediatos: "{{n}} di questi promemoria partono nei prossimi minuti: il loro orario di invio è già arrivato.",
          rangoDeclarado: "Intervallo del file: dal {{desde}} al {{hasta}} (dichiarato nella riga {{fila}}).",
          rangoDerivado: "Intervallo del file: dal {{desde}} al {{hasta}} (calcolato dalle righe: il file non lo dichiara).",
          sinRango: "Impossibile determinare l'intervallo del file.",
          rangoEfectivo: "Il confronto parte dal {{desde}}: ciò che è precedente non si crea né si annulla.",
          servicioUsado: "Servizio: {{nombre}}",
          chipLeidas: "{{n}} righe lette",
          chipCrear: "{{n}} da creare",
          chipExistentes: "{{n}} già esistenti",
          chipPasadas: "{{n}} passate (ignorate)",
          chipCancelar: "{{n}} da annullare",
          chipIncidencias: "{{n}} anomalie",
          checksumOk: "Controllo righe: {{leidas}} su {{declaradas}}",
          checksumMal: "Il controllo righe NON coincide: {{leidas}} lette, {{declaradas}} dichiarate",
          telefonos: "Telefoni: {{moviles}} con 15, {{asumidos}} considerati cellulari, {{invalidos}} non validi",
          switchRecordatorios: "Inviare i promemoria programmati a questi {{appointmentPlural}}",
          switchRecordatoriosAyuda: "La conferma di prenotazione non viene inviata: il cliente si è già accordato con il consulente.",
          asesoresTitulo: "Consulenti del file e relativo {{professional}}",
          asesoresSinAsociar: "{{n}} non associati: le loro righe non vengono caricate",
          sinAsociar: "Non associato",
          guardarAsesores: "Salva associazioni",
          cancelarTitulo: "Vengono annullati {{n}} {{appointmentPlural}}",
          cancelarAyuda: "Erano stati caricati da un file precedente e non compaiono in questo. Non si annulla mai ciò che ha fissato l'assistente o che è stato caricato a mano.",
          colCliente: "Cliente",
          colSucursal: "{{professional_c}}",
          colFecha: "Data",
          colHora: "Ora",
          incidenciasTitulo: "{{n}} righe con anomalie (non vengono caricate)",
          protegidosTitulo: "{{n}} {{appointmentPlural}} non vengono annullati perché la loro riga ha un'anomalia",
          protegido: "{{cliente}} — {{fecha}} {{hora}}",
          fila: "Riga {{n}}",
          archivo: "File",
          importado: "Caricamento #{{lote}}: {{creados}} creati, {{cancelados}} annullati",
          importadoConIncidencias: "{{n}} righe non sono state caricate: controlla le anomalie nella cronologia",
          revertido: "Caricamento #{{lote}} annullato: {{borrados}} eliminati, {{restaurados}} ripristinati",
          revertResultado: "Caricamento #{{lote}} annullato: {{borrados}} eliminati e {{restaurados}} ripristinati.",
          revertPasosSaltados: "{{n}} promemoria scaduti mentre l'appuntamento era annullato non verranno inviati.",
          noRevertiblesTitulo: "{{n}} non sono stati annullati (hanno avuto modifiche dopo il caricamento):",
          historialVacio: "Non ci sono ancora caricamenti.",
          colCargado: "Caricato",
          colArchivo: "File",
          colRango: "Intervallo",
          colCreados: "Creati",
          colCancelados: "Annullati",
          colExistentes: "Già esistenti",
          colIncidencias: "Anomalie",
          colEstado: "Stato",
          estadoRevertido: "Annullato",
          estadoAplicado: "Applicato",
          sinRecordatorios: "senza promemoria",
          revertir: "Annulla",
          historialAyuda: "Si può annullare solo l'ultimo caricamento applicato.",
          cerrar: "Chiudi",
          confirmar: "Conferma: creare {{crear}} e annullare {{cancelar}}",
          revertirTitulo: "Annullare il caricamento #{{lote}}",
          revertirTexto: "Vengono eliminati i {{creados}} {{appointmentPlural}} creati (tranne quelli già modificati) e ripristinati i {{cancelados}} annullati. Nessun messaggio viene inviato."
        },
      },
      agenda: {
        cargarAMano: "Carica a mano",
        asignarA: "Assegna a",
        sinRecurrencia: "Nessuna ricorrenza",
        sinAcceso: "Nessun accesso",
        accesoPermanente: "Accesso permanente",
        accesoPorCaso: "Caso per caso (richiede approvazione)",
        placeholderBloque: "es: controllo, revisione, urgenza",
        alertasTitulo: "Avvisi di blocchi speciali annullati",
        sinAlertas: "Nessun avviso in sospeso.",
        sinAsignados: "Non hai ancora nulla assegnato.",
        color: "Colore:",
        slot: "Spazio:",
        nombrePaciente: "Nome del paziente *",
        telefono: "Telefono *",
        email: "Email (opzionale)",
        profesional: "Professionista",
        profesionalReq: "Professionista *",
        servicio: "Servizio *",
        helperTelefono: "Con prefisso internazionale, es: 393512345678",
        nombreBloque: "Nome del blocco *",
        inicio: "Inizio *",
        fin: "Fine *",
        duracionSlot: "Durata per slot (minuti)",
        recurrencia: "Ricorrenza",
        accesoAgendador: "Accesso {{delScheduler}}",
        fecha: "Data *",
        sinSlots: "Nessuno slot disponibile per quella data",
        seleccionarProfFechaSvc: "Seleziona {{professional}}, data e {{service}}",
        guardarTurno: "Salva",
        asignar: "Assegna",
        crearBloque: "Crea blocco",
        habilitarSobreturno: "Abilita appuntamento extra",
        habilitarSobreturnos: "Abilita appuntamenti extra",
        solicitarAcceso: "Richiedi accesso",
        actualizar: "Aggiorna",
        llamarSiguiente: "Chiama il successivo",
        llamar: "Chiama",
        enviarRecordatorio: "Invia promemoria",
        agendadorSinAcceso: "{{scheduler_c}} senza accesso",
        agendadorConAcceso: "{{scheduler_c}} con accesso",
        desactivarBloque: "Disattiva blocco",
        especial: "Speciale",
        libre: "Libero",
        reservado: "Riservato",
        pacienteNotificado: "Avvisato via WhatsApp",
        turnoActualizadoSinWA: "Aggiornato, ma WhatsApp non era disponibile",
        errorLlamarSiguiente: "Errore nel chiamare il successivo",
        recordatorioEnviado: "Promemoria inviato",
        errorRecordatorio: "Errore nell'invio del promemoria",
        sobreturnuHabilitado: "Appuntamento extra abilitato per oggi",
        errorSobreturno: "Impossibile abilitare l'appuntamento extra",
        sobretornosHabilitados: "Appuntamenti extra abilitati per oggi",
        sobretornosDeshabilitados: "Appuntamenti extra disabilitati",
        errorSobreturnos: "Errore nell'aggiornamento degli appuntamenti extra",
        bloqueCreado: "Blocco speciale creato",
        errorBloque: "Errore nella creazione del blocco",
        pacienteAsignado: "Assegnato al blocco speciale",
        errorAsignar: "Impossibile assegnare",
        errorAsignarSimple: "Errore nell'assegnazione",
        solicitudEnviada: "Richiesta inviata",
        errorSolicitud: "Errore nell'invio della richiesta",
        errorAcceso: "Impossibile aggiornare l'accesso",
        bloqueDesactivado: "Blocco disattivato",
        errorDesactivar: "Errore nella disattivazione del blocco",
        errorCargarDatos: "Errore nel caricamento dei dati",
        camposObligatorios: "Compila tutti i campi obbligatori (*)",
        campoRequerido: "Il campo \"{{label}}\" è obbligatorio",
        eligeHorario: "Scegli un orario",
        turnoCargado: "Fatto, è stato prenotato",
        errorCargarTurno: "Impossibile prenotare",
        usuarioSinProfesional: "Il tuo utente non è collegato. Contatta l'amministratore.",
        errorProfesionales: "Impossibile caricare la lista.",
      },
      profesionales: {
        titulo: "Professionisti",
        agregarBtn: "Aggiungi",
        headerNombre: "Nome",
        headerEspecialidad: "Specialità",
        headerCapacidad: "Simultanei",
        headerCupoDiario: "Limite al giorno",
        headerEstado: "Stato",
        headerAcciones: "Azioni",
        sinProfesionales: "Non hai ancora aggiunto {{professionalPlural}}.",
        sinEspecialidad: "Senza {{specialty}}",
        cancelar: "Annulla",
        nuevo: "Aggiungi {{professional}}",
        editar: "Modifica {{professional}}",
        activo: "Attivo",
        inactivo: "Inattivo",
        activar: "Attiva",
        desactivar: "Disattiva",
        nombre: "Nome *",
        especialidad: "Specialità",
        emailReq: "Email *",
        email: "Email",
        passwordReq: "Password *",
        nuevaPassword: "Nuova password",
        helperPassword: "Lascia vuoto per non modificare",
        consultorio: "Studio",
        capacidad: "Attenzione simultanea",
        capacidadUnidad: "appuntamenti",
        capacidadAyuda: "Quanti {{appointmentPlural}} può gestire contemporaneamente (1 = uno alla volta)",
        cupoDiario: "Limite di appuntamenti al giorno",
        cupoDiarioAyuda: "Facoltativo. Vuoto = nessun limite. Limita ciò che fissa l'assistente; dal pannello si può inserire lo stesso.",
        consultorioPlaceholder: "es: 1, 3, A",
        queueWarning: "L'utente è stato creato ma non è stato possibile assegnare una coda. Assegnala manualmente da WAIA.",
        guardar: "Salva",
        errorNombre: "Il nome è obbligatorio",
        errorCredenciales: "Email e password sono obbligatorie",
        errorGuardar: "Non è stato possibile salvare. Controlla i dati e riprova.",
        tooltipEditar: "Modifica",
      },
      precios: {
        titulo: "Prezzi",
        importar: "Importa",
        historial: "Storico",
        sinLista: "Non hai ancora caricato un listino prezzi.",
        vigenteDesdeChip: "In vigore dal {{fecha}}",
        importadaEl: "Importata il {{fecha}}",
        listaVencida: "Questo listino ha {{dias}} giorni e il limite configurato è di {{umbral}}. Aggiornalo: l'assistente non darà prezzi di un listino scaduto.",
        buscar: "Cerca",
        todos: "Tutti",
        headerPrecio: "Prezzo",
        headerAcciones: "Azioni",
        headerItems: "Prezzi",
        headerEstado: "Stato",
        noAplica: "Non applicabile",
        estadoActivo: "Con prezzo",
        sinResultados: "Nessun prezzo corrisponde al filtro.",
        editar: "Correggi",
        editarTitulo: "Correggi prezzo",
        etiqueta: "Etichetta",
        helperPrecio: "Lascialo vuoto se non ha un prezzo caricato.",
        helperEtiqueta: 'Per offerte con nome, come "Revisione Gratuita". Si dice al posto del numero.',
        avisoAtributos: "Per cambiare a cosa corrisponde questo prezzo, correggi il file e reimportalo.",
        rangoFiltroPlaceholder: "Scrivi un valore",
        borrarLista: "Elimina",
        estado_active: "In uso",
        estado_archived: "Archiviata",
        estado_draft: "Bozza",
        importarTitulo: "Importa listino prezzi",
        formato: "Tipo di foglio",
        formato_matrix_km: "Una riga per veicolo e una colonna per chilometraggio",
        formato_long_csv: "CSV: un prezzo per riga",
        formatoHelp_matrix_km: "Il tabellone di sempre: ogni riga è un modello, ogni colonna un tagliando (10.000, 20.000…) e gli aggiuntivi in fondo.",
        formatoHelp_long_csv: "Una riga per prezzo. Le colonne che non siano prezzo, stato, etichetta o nota si prendono come dati del prezzo.",
        formato_ejes_declarados: "Con foglio di configurazione (CONFIG)",
        formatoHelp_ejes_declarados: "Il foglio nuovo: oltre ai prezzi ha un foglio CONFIG che dice cos'è ogni colonna (modello, versione, anni, chilometraggio).",
        rechazan: "{{count}} problema impedisce l'importazione",
        cobertura: "Copertura per soggetto",
        sinPreciosPara: "nessun prezzo per {{v}}",
        dejarEnBorrador: "Lascia in bozza (non sostituisce ancora il listino in uso)",
        avisoBorrador: "Il listino viene caricato ma NON entra in uso: puoi rivederlo e attivarlo dopo. L'assistente continua a rispondere con il listino in uso.",
        elegirArchivo: "Tocca qui per scegliere il file (.xlsx o .csv)",
        resumen: "Cosa contiene il file",
        ejes: "Si raggruppa per",
        chipTotal: "{{n}} prezzi",
        chipActivos: "{{n}} con prezzo",
        chipNoAplica: "{{n}} non applicabili",
        chipOmitidas: "{{n}} non si caricano",
        diffPrimera: "È il primo listino: è tutto nuovo.",
        diffContra: 'Confrontato con "{{lista}}"',
        diffNuevos: "{{n}} nuovi",
        diffSubieron: "{{n}} aumentati",
        diffBajaron: "{{n}} diminuiti",
        diffIguales: "{{n}} invariati",
        diffCambiosEstado: "{{n}} cambiano stato",
        diffDesaparecidos: "{{n}} scompaiono",
        diffItem: "Articolo",
        diffAntes: "Prima",
        diffDespues: "Adesso",
        diffCambio: "Variazione",
        diffKind_nuevo: "Nuovo",
        diffKind_subio: "Aumentato",
        diffKind_bajo: "Diminuito",
        diffKind_igual: "Invariato",
        diffKind_cambio_estado: "Cambia stato",
        diffKind_desaparecido: "Scompare",
        noSeCargan: "{{count}} cella non verrà caricata",
        avisos: "{{count}} avviso",
        nombreLista: "Nome del listino",
        vigenteDesde: "In vigore dal",
        vigenciaDelArchivo: "L'abbiamo presa dal file. Cambiala se non è corretta.",
        vigenciaFaltante: "Il file non la contiene: indica da quando è in vigore.",
        incluyeIva: "I prezzi includono l'IVA?",
        ivaSi: "Sì, IVA inclusa",
        ivaNo: "No, IVA esclusa",
        ivaNoSe: "Non si sa",
        avisoReemplazo: "Confermando, questo listino diventa quello in vigore e il precedente viene archiviato.",
        errorLeer: "Non è stato possibile leggere il file.",
        errorImportar: "Non è stato possibile importare il file.",
        validezTitulo: "Scadenza del listino prezzi",
        validezLabel: "Avvisa quando il listino supera i (giorni)",
        validezHelper: "Vuoto = nessun controllo di scadenza. Con un numero, il listino viene segnalato come scaduto dopo quei giorni e l'assistente smette di darne i prezzi.",
        formatoDetectado: "Tipo di foglio (riconosciuto automaticamente)",
        formatoDetectadoHelp: "L'abbiamo scelto guardando il file. Cambialo solo se non è corretto: il file viene riletto.",
        importarAyuda: "È il listino che l'assistente usa per rispondere alle domande. Carica l'Excel che tiene l'azienda: prima di salvare qualsiasi cosa ti mostriamo cosa contiene, cosa cambia rispetto al listino attuale e cosa va corretto.",
        archivoElegido: "{{nombre}} — tocca per sceglierne un altro",
        leyendoArchivo: "Lettura del file…",
        rechazan_plural: "{{count}} problemi impediscono l'importazione",
        rechazanAyuda: "Correggili nell'Excel (la cella è accanto a ciascuno) e scegli di nuovo il file.",
        noSeCargan_plural: "{{count}} celle non verranno caricate",
        avisos_plural: "{{count}} avvisi",
        incGenerico: "{{count}} caso",
        incGenerico_plural: "{{count}} casi",
        incVerTodas: "Vedi tutti i {{n}}",
        incVerMenos: "Vedi meno",
        incMasCeldas: "e altre {{n}}",
        inc_CELDA_CON_ERROR: "{{count}} cella con errore di formula",
        inc_CELDA_CON_ERROR_plural: "{{count}} celle con errore di formula",
        inc_COLUMNA_IGNORADA: "{{count}} colonna che non è un chilometraggio valido",
        inc_COLUMNA_IGNORADA_plural: "{{count}} colonne che non sono un chilometraggio valido",
        inc_CONFIG_CLAVE_IGNORADA: "{{count}} voce del foglio CONFIG non usata",
        inc_CONFIG_CLAVE_IGNORADA_plural: "{{count}} voci del foglio CONFIG non usate",
        inc_CONFIG_IVA_ILEGIBLE: "L'IVA del foglio CONFIG non si è potuta leggere",
        inc_CONFIG_IVA_ILEGIBLE_plural: "L'IVA del foglio CONFIG non si è potuta leggere",
        inc_EJES_INFERIDOS: "Le colonne sono state riconosciute automaticamente",
        inc_EJES_INFERIDOS_plural: "Le colonne sono state riconosciute automaticamente",
        inc_ESCALA_CON_SALTO: "{{count}} salto nei chilometraggi (può mancare una colonna)",
        inc_ESCALA_CON_SALTO_plural: "{{count}} salti nei chilometraggi (può mancare una colonna)",
        inc_FILA_SIN_PRECIOS: "{{count}} riga senza alcun prezzo",
        inc_FILA_SIN_PRECIOS_plural: "{{count}} righe senza alcun prezzo",
        inc_ITEM_DUPLICADO: "{{count}} prezzo ripetuto",
        inc_ITEM_DUPLICADO_plural: "{{count}} prezzi ripetuti",
        inc_MONEDA_IGNORADA: "La colonna della valuta non si usa",
        inc_MONEDA_IGNORADA_plural: "La colonna della valuta non si usa",
        inc_PRECIO_CERO_CON_ETIQUETA: "{{count}} prezzo a 0 detto con la sua nota",
        inc_PRECIO_CERO_CON_ETIQUETA_plural: "{{count}} prezzi a 0 detti con la loro nota",
        inc_PRECIO_CERO_SIN_ETIQUETA: "{{count}} prezzo a 0 senza nota",
        inc_PRECIO_CERO_SIN_ETIQUETA_plural: "{{count}} prezzi a 0 senza nota",
        inc_PRECIO_COMO_TEXTO: "{{count}} prezzo scritto come testo",
        inc_PRECIO_COMO_TEXTO_plural: "{{count}} prezzi scritti come testo",
        inc_RANGO_CON_HUECO: "{{count}} buco tra gli anni",
        inc_RANGO_CON_HUECO_plural: "{{count}} buchi tra gli anni",
        inc_RANGO_INVALIDO: "{{count}} intervallo di anni scritto male",
        inc_RANGO_INVALIDO_plural: "{{count}} intervalli di anni scritti male",
        inc_SEPARADOR_AMBIGUO: "{{count}} prezzo con separatore dubbio",
        inc_SEPARADOR_AMBIGUO_plural: "{{count}} prezzi con separatore dubbio",
        inc_SUJETO_INCOMPLETO: "{{count}} riga con prezzi ma senza modello",
        inc_SUJETO_INCOMPLETO_plural: "{{count}} righe con prezzi ma senza modello",
        inc_SUJETO_VARIAS_PALABRAS: "{{count}} valore con parole in più",
        inc_SUJETO_VARIAS_PALABRAS_plural: "{{count}} valori con parole in più",
        inc_TEXTO_COMO_ETIQUETA: "{{count}} testo caricato come etichetta",
        inc_TEXTO_COMO_ETIQUETA_plural: "{{count}} testi caricati come etichetta",
        inc_RANGO_SOLAPADO: "{{count}} coppia di righe con anni sovrapposti",
        inc_RANGO_SOLAPADO_plural: "{{count}} coppie di righe con anni sovrapposti",
        inc_RANGO_DOS_ABIERTOS: "{{count}} modello con due righe senza \"a\"",
        inc_RANGO_DOS_ABIERTOS_plural: "{{count}} modelli con due righe senza \"a\"",
        ivaHelp_si: "L'assistente può dire che i prezzi includono l'IVA.",
        ivaHelp_no: "L'assistente può chiarire che i prezzi non includono l'IVA.",
        ivaHelp_nose: "L'assistente non menziona l'IVA.",
        ivaSiCorto: "Inclusa",
        ivaNoCorto: "Esclusa",
        ivaNoSeCorto: "Non si sa",
        incluyeIvaCorto: "IVA",
        crearPrecios: "Crea {{count}} prezzo",
        crearPrecios_plural: "Crea {{count}} prezzi",
        crearBorrador: "Crea {{count}} prezzo in bozza",
        crearBorrador_plural: "Crea {{count}} prezzi in bozza",
        crearSinArchivo: "Crea prezzi",
        creando: "Creazione…",
        motivoSinArchivo: "Scegli un file per iniziare.",
        motivoNoSeLeyo: "Non è stato possibile leggere il file: vedi il messaggio sopra.",
        motivoErrores: "Impossibile importare: c'è {{count}} problema nel file, segnato in rosso.",
        motivoErrores_plural: "Impossibile importare: ci sono {{count}} problemi nel file, segnati in rosso.",
        motivoVacio: "Il file non ha nessun prezzo da caricare.",
        motivoSinVigencia: "Indica da quando vale il listino.",
        cancelar: "Annulla",
        guardar: "Salva",
        cerrar: "Chiudi",
        historialAyuda: "Il listino «In uso» è quello che consulta l'assistente. Una bozza non lo sostituisce finché non la attivi.",
        borradoresTitulo: "C'è {{count}} listino in bozza non attivato",
        borradoresTitulo_plural: "Ci sono {{count}} listini in bozza non attivati",
        borradoresAyuda: "L'assistente usa ancora «{{vigente}}». Controlla la bozza e attivala quando è pronta.",
        borradoresAyudaSinVigente: "Non c'è ancora un listino in uso: l'assistente non dà prezzi finché non ne attivi uno.",
        borradorDetalle: "{{n}} prezzi · importato il {{fecha}}",
        verPrecios: "Vedi prezzi",
        probar: "Prova",
        activar: "Attiva",
        viendoLista: "Stai guardando «{{lista}}» ({{estado}}). Non è il listino che usa l'assistente.",
        volverAVigente: "Torna al listino in uso",
        activarTitulo: "Attiva «{{lista}}»",
        activarFrase: "Il listino «{{nueva}}» diventa quello che usa l'assistente. L'attuale «{{actual}}» viene archiviato.",
        activarFraseSinVigente: "Il listino «{{nueva}}» diventa quello che usa l'assistente.",
        activarColVigente: "In uso ora",
        activarColNueva: "Quello che entra",
        activarProbarAntes: "Hai dubbi? Provalo prima: cerca un veicolo reale e confronta cosa risponderebbe ogni listino.",
        activarBoton: "Attiva",
        activarError: "Non è stato possibile attivare il listino.",
        activada: "«{{lista}}» è ora il listino che usa l'assistente.",
        chipActivosCorto: "Con prezzo",
        incidencias: "Problemi dell'importazione",
        incNinguna: "Nessuno",
        incNoRegistradas: "Non registrati",
        incNoRegistradasAyuda: "Questo listino è stato importato prima che si registrassero i problemi. Per vederli, scegli di nuovo lo stesso file in Importa (l'anteprima non salva nulla).",
        incQuedaronAfuera: "{{count}} cella è rimasta fuori",
        incQuedaronAfuera_plural: "{{count}} celle sono rimaste fuori",
        borrarTitulo: "Elimina listino",
        borrarFrase: "Verrà eliminato «{{lista}}» con i suoi {{n}} prezzi. Non si può annullare. Il listino in uso non cambia.",
        borrarBoton: "Elimina",
        borrarError: "Non è stato possibile eliminare il listino.",
        borrada: "«{{lista}}» è stato eliminato.",
        importadaBorrador: "«{{lista}}» è rimasto in bozza. Attivalo dopo averlo controllato.",
        importadaVigente: "Il nuovo listino è già in uso.",
        probarTitulo: "Prova «{{lista}}»",
        probarAyuda: "Fai la stessa ricerca che farebbe l'assistente con un cliente reale.",
        probarAyudaComparar: "Fai la stessa ricerca che farebbe l'assistente e confronta con ciò che risponde oggi «{{vigente}}».",
        probarVehiculo: "Veicolo",
        probarRango: "anno",
        probarUltimoService: "Ultimo tagliando (km)",
        probarKmActual: "Km attuali",
        probarItemOpcional: "Aggiuntivo (facoltativo)",
        probarConsultar: "Cerca",
        probarError: "Non è stato possibile fare la ricerca.",
        probarEsta: "«{{lista}}»",
        probarEnUso: "In uso: «{{lista}}»",
        probarModelo: "Modello",
        probarItem: "Articolo",
        probarServiceQueToca: "Tagliando previsto: {{km}} km",
        probarAtrasado: "In ritardo di {{km}} km",
        probarFalta: "Manca il dato: {{dato}}",
        probarRes_precio: "Dà il prezzo",
        probarRes_no_aplica: "Non si applica a quel veicolo",
        probarRes_modelo_ambiguo: "Chiede quale modello",
        probarRes_item_ambiguo: "Chiede quale aggiuntivo",
        probarRes_anio_faltante: "Chiede: {{eje}}",
        probarRes_anio_sin_cobertura: "Nessun prezzo per quel valore di «{{eje}}» → passa a un operatore",
        probarRes_falta_dato: "Chiede un dato mancante",
        probarRes_km_incoherentes: "I km non tornano (quelli attuali sono meno dell'ultimo tagliando) → chiarisce con il cliente",
        probarRes_sin_dato: "Nessun prezzo trovato → passa a un operatore",
        probarRes_fuera_de_grilla: "Chilometraggio fuori listino → passa a un operatore",
        probarRes_salteo_intervalos: "Ha saltato tagliandi → passa a un operatore",
        probarRes_lista_vencida: "Listino scaduto → passa a un operatore senza prezzo",
        probarRes_sin_lista: "Nessun listino → passa a un operatore",
      },
      servicios: {
        titulo: "Servizi",
        tituloSeccion: "Servizi",
        nuevo: "Aggiungi {{service}}",
        editar: "Modifica {{service}}",
        activo: "Attivo",
        inactivo: "Inattivo",
        activar: "Attiva",
        desactivar: "Disattiva",
        cualquiera: "Qualsiasi",
        nombre: "Nome *",
        duracion: "Durata (minuti)",
        profesionalAsignado: "Chi lo esegue",
        guardar: "Salva",
        cancelar: "Annulla",
        tooltipEditar: "Modifica",
        headerNombre: "Nome",
        headerDuracion: "Durata",
        headerEntrega: "Consegna",
        headerPrecio: "Prezzo",
        precio: "Prezzo",
        helperPrecio: "Facoltativo. Nella valuta del tuo Paese — non serve indicarla.",
        helperDuracion: "Quanto occupa in agenda (il passo della griglia degli orari).",
        entrega: "Tempo di consegna (minuti)",
        helperEntrega: "Facoltativo. Quando si consegna il lavoro finito. Non occupa l'agenda: è ciò che l'assistente dice al cliente.",
        descripcion: "Descrizione",
        helperDescripcion: "Facoltativa. La mostriamo {{alPatient}} e aiuta l'assistente a capire di quale {{service}} si parla.",
        headerProfesional: "Professionista",
        headerEstado: "Stato",
        headerAcciones: "Azioni",
        agregarBtn: "Aggiungi",
        sinServicios: "Non hai ancora aggiunto {{servicePlural}}.",
        borrar: "Elimina definitivamente",
        borrarTitulo: "Elimina {{service}}",
        borrarTexto: "«{{name}}» viene rimosso dall'elenco, per sempre. Disattivarlo lo toglie dalla circolazione ma lo lascia nello storico; questo no.",
        borrarConfirmar: "Elimina",
        borrarCancelar: "Annulla",
        borrarOk: "Fatto, è stato eliminato",
        borrarEnUso: "Non si può eliminare: ha {{count}} {{appointmentPlural}} nel suo storico. Si può solo disattivare.",
        borrarEnUsoOtros: "Non si può eliminare: è in uso in altre parti del sistema. Si può solo disattivare.",
        borrarError: "Non è stato possibile eliminare",
      },
      agendadores: {
        titulo: "Segretari",
        tituloSeccion: "Segretarie",
        descripcion: "Chi carica {{appointmentPlural}} a mano, per {{losProfessionalPlural}} di sua competenza. Può anche abilitare gli extra in giorni specifici.",
        nuevo: "Aggiungi {{scheduler}}",
        editar: "Modifica {{scheduler}}",
        activo: "Attivo",
        inactivo: "Inattivo",
        activar: "Attiva",
        desactivar: "Disattiva",
        nombre: "Nome *",
        email: "Email",
        emailReq: "Email *",
        passwordReq: "Password *",
        nuevaPassword: "Nuova password (opzionale)",
        helperPassword: "Lascia vuoto per non modificare",
        guardar: "Salva",
        cancelar: "Annulla",
        tooltipEditar: "Modifica",
        errorNombre: "Il nome è obbligatorio",
        errorCredenciales: "Email e password sono obbligatorie",
        errorEmailOtroPerfil: "Questa email appartiene già a un utente con profilo {{perfil}} dell'azienda. Usa un'altra email: la password digitata non si applica a un utente già esistente.",
        errorGuardar: "Impossibile salvare. Riprova.",
        usuarioReutilizado: "Questo utente esisteva già in WAIA: accede con la password precedente, quella digitata non è stata applicata.",
        perfil: {
          admin: "amministratore",
          user: "utente",
          profesional: "professionista",
          agendador: "segretario",
          desconocido: "sconosciuto",
        },
        headerNombre: "Nome",
        headerEmail: "Email",
        headerProfesionales: "Professionisti assegnati",
        headerEstado: "Stato",
        headerAcciones: "Azioni",
        agregarBtn: "Aggiungi",
        sinAgendadores: "Non hai ancora aggiunto {{schedulerPlural}}.",
        sinAsignacion: "Nessuna assegnazione",
        profesionalesLabel: "Professionisti assegnati",
        noProfesionales: "Non ci sono ancora {{professionalPlural}} disponibili.",
      },
      recordatorios: {
        titulo: "Promemoria",
        tipo: "Tipo",
        estado: "Stato",
        pendiente: "In attesa",
        enviado: "Inviato",
        fallido: "Fallito",
        respondido: "Risposto",
        saltado: "Saltato",
        todosLosTipos: "Tutti i tipi",
        todosLosEstados: "Tutti gli stati",
        historial: "Storico dei promemoria",
        seguimiento: "Monitoraggio dei promemoria inviati. Il sistema li invia da solo, secondo la configurazione dell'azienda.",
        paciente: "Paziente",
        programadoPara: "Programmato per",
        vistaPrev: "Anteprima",
        noHayRegistros: "Nessun promemoria registrato",
        sinDatos: "Nessun dato di promemoria disponibile",
        confirmacionReserva: "Conferma prenotazione",
        recordatorioSimple: "Promemoria",
        solicitudConfirmacion: "Richiesta di conferma",
        ofertaRebalanceo: "Offerta di riequilibrio",
        ofertaListaEspera: "Offerta dalla lista d'attesa",
      },
      configuracion: {
        titulo: "Configurazione della disponibilità",
        horariosAtencion: "Orari di ricevimento",
        agregarHorario: "Aggiungi orario",
        dia: "Giorno",
        desde: "Da",
        hasta: "A",
        acciones: "Azioni",
        sinHorarios: "Nessun orario configurato",
        cupoVentana: "Limite della fascia",
        cupoVentanaAyuda: "Facoltativo. Vuoto = nessun limite. Quanti appuntamenti accetta questa fascia; limita l'assistente, non il pannello.",
        editar: "Modifica",
        editarHorario: "Modifica orario",
        bloqueosAgenda: "Blocchi agenda",
        agregarBloqueo: "Aggiungi blocco",
        motivo: "Motivo",
        sinBloqueos: "Nessun blocco",
        eliminar: "Elimina",
        diaSemana: "Giorno della settimana",
        horaInicio: "Ora inizio",
        horaFin: "Ora fine",
        fechaHoraInicio: "Data/ora inizio",
        fechaHoraFin: "Data/ora fine",
        motivoOpcional: "Motivo (opzionale)",
        cancelar: "Annulla",
        guardar: "Salva",
      },
      listaEspera: {
        titulo: "Lista d'attesa",
        descripcion: "Chi ha chiesto un posto e non ha trovato disponibilità. Li avvisiamo in automatico se si libera qualcosa di compatibile.",
        tituloLista: "Lista d'attesa",
        profesional: "Professionista",
        servicio: "Servizio",
        estado: "Stato",
        cualquiera: "Qualsiasi",
        todos: "Tutti",
        tooltipEliminar: "Rimuovi dalla lista",
        enEspera: "In attesa",
        ofertaEnviada: "Offerta inviata",
        confirmado: "Confermato",
        expirado: "Scaduto",
        eliminado: "Eliminato",
        pendiente: "In attesa",
        enCurso: "In corso",
        completado: "Completato",
        fallido: "Fallito",
        abandonado: "Abbandonato",
        listaEspera: "Lista d'attesa",
        adelantamiento: "Anticipo",
        eliminar: "Elimina",
        cancelar: "Annulla",
        headerPaciente: "Paziente",
        headerProfesional: "Professionista",
        headerServicio: "Servizio",
        headerPedido: "Giorno/ora richiesti",
        sinPreferencia: "Nessuna preferenza",
        headerIngreso: "Inserito",
        headerVence: "Scade",
        headerEstado: "Stato",
        headerAcciones: "Azioni",
        noHayPacientes: "Non c'è nessuno in attesa.",
        enEsperaCount: "{{count}} in attesa",
        historialRebalanceos: "Storico riequilibri",
        histHeaderId: "ID",
        histHeaderTurno: "Posto liberato",
        histHeaderProfesional: "Professionista",
        histHeaderEstado: "Stato",
        histHeaderFase: "Fase",
        histHeaderIntentos: "Tentativi",
        histHeaderIniciado: "Avviato",
        sinHistorial: "Nessuno storico di riequilibri",
        eliminarDialogTitle: "Rimuovi dalla lista d'attesa",
        confirmarEliminar: "Confermi la rimozione di",
        estePaciente: "questa persona",
        deListaEspera: "dalla lista d'attesa? Questa azione non può essere annullata.",
      },
      identificadorContacto: {
        title: "Identificativo del contatto",
        help: "Il dato che identifica ciò che il contatto porta —la targa in un'officina, il nome dell'animale in un veterinario, il numero di serie in un centro assistenza—. Viene mostrato accanto al nome nella chat e nella scheda del contatto. Se ci sono più chiavi, si usa la prima con un valore.",
        clave: "Chiave della scheda",
        etiqueta: "Etichetta",
        fichas: "{{n}} schede con il dato",
        agregar: "Aggiungi chiave",
        quitar: "Rimuovi",
        guardar: "Salva",
        guardado: "Identificativo salvato",
        sinFichas: "Non ci sono ancora schede: le chiavi compaiono con la prima campagna. Puoi comunque scrivere la chiave.",
        vacio: "Nessun identificativo: accanto al nome non viene mostrato nulla.",
        max: "Massimo 3 chiavi.",
      },
      ajustes: {
        voiceTemplateDefault: "{nombre}, vai a {consultorio}, con {profesional}. Ripeto: {nombre}, vai a {consultorio}.",
        salaProfesionales: "{{professionalPlural_c}} (vuoto = senza filtro)",
        salaSoloInicial: "Mostra solo l'iniziale del cognome",
        salaDing: "Ding dong a ogni chiamata",
        salaVoz: "Annuncio vocale",
        salaProximos: "Mostra chi segue",
        salaAnteriores: "Mostra chi è già passato",
        nombreNegocio: "Nome dell'attività",
        nombreNegocioPlaceholder: "Es: Officina Junín, Studio Gazzera",
        grupoAgendaVentana: "Agenda → Finestra di prenotazione",
        dias: "giorni",
        metaEnRevision: "In revisione",
        metaNoCreada: "Non creata",
        metaDentro24: "entro le 24 ore",
        metaNoRequieren: "non richiedono l'approvazione di Meta",
        metaAprobada: "modello approvato da Meta",
        metaSoloLectura: "sola lettura",
        solicitudConfirmacion: "Richiesta di conferma",
        opModoTitle: "Modalità operativa",
        opModoDesc: "Definisce cosa fa l'IA quando non riesce a risolvere qualcosa e a chi arriva il caso.",
        opModoActivo: "Attuale",
        opModoLocked: "Disponibile in un piano superiore — contattaci per attivarlo",
        opEffectiveLabel: "A chi arrivano oggi i casi:",
        opGuardarModo: "Salva modalità",
        opDestinatarioChat: "+ chat WhatsApp",
        opModo: {
          desatendido: {
            title: "Non presidiato",
            desc: "L'IA gestisce da sola. Se non riesce a risolvere qualcosa, lascia il caso nella tua agenda. Non promette assistenza umana dal vivo.",
          },
          atendido: {
            title: "Presidiato",
            desc: "L'IA gestisce; i casi che non riesce a risolvere vanno alla segretaria / addetto.",
          },
          con_chat: {
            title: "Con chat",
            desc: "Inoltre, il tuo team può rispondere dalla chat di WhatsApp. L'IA può passare a una persona.",
          },
        },
        opDestinatario: {
          profesionales: "I professionisti (ogni caso appare nell'agenda del professionista dell'appuntamento)",
          rol: "La segretaria / addetto",
          usuario: "Un utente designato",
          admin: "L'amministratore",
        },
        grupoAsistente: "Assistente",
        // ── Interruttore dell'IA ──────────────────────────────────────────
        // Il testo dice cosa fa E cosa NON fa: spegnere l'IA non spegne i
        // promemoria, e quella confusione lascia un'azienda senza prodotto.
        iaOn: "L'assistente risponde ai messaggi in arrivo",
        iaOff: "L'assistente NON risponde: se ne occupa una persona",
        iaDesc: "Con l'assistente spento, i messaggi in arrivo non vengono passati all'IA: restano nella casella Chat perché li gestisca una persona. È una modalità operativa, non una modalità di manutenzione — puoi lasciarlo spento quanto vuoi.",
        iaNoApagaRecordatorios: "⛔ Spegnere l'assistente NON spegne i promemoria: i promemoria programmati, le conferme di prenotazione e le campagne in uscita continuano a essere inviati.",
        iaUltimoCambio: "Ultima modifica:",
        iaPorUsuario: "dall'utente",
        iaPrendidaOk: "L'assistente risponde di nuovo ai messaggi in arrivo.",
        iaApagadaOk: "Assistente spento. I messaggi in arrivo restano nella casella. I promemoria continuano a partire.",
        iaNoHabilitada: "L'assistente non è abilitato per il tuo account",
        iaNoHabilitadaDesc: "Questa funzione non è abilitata per il tuo account. Scrivici se vuoi attivarla.",
        remTitle: "Promemoria programmati",
        remOn: "I promemoria programmati partono",
        remOff: "I promemoria programmati NON partono",
        remDesc: "I passaggi che hai configurato qui sotto (30 giorni prima, 24 ore prima, ecc.). Ogni promemoria è un messaggio template di WhatsApp e ha un costo. Spegnerli non cancella nulla: quando li riaccendi, la coda riprende da dov'era.",
        remNoApagaConfirmacion: "⛔ Spegnere i promemoria programmati NON spegne la conferma inviata quando si crea un appuntamento (quella la controlla l'opzione \"notifica\" dell'appuntamento) né le campagne in uscita.",
        remNoHabilitados: "I promemoria programmati non sono abilitati per il tuo account",
        remNoHabilitadosDesc: "Questa funzione non è abilitata per il tuo account. Scrivici se vuoi attivarla.",
        remPrendidosOk: "I promemoria programmati tornano a partire. La coda riprende da dov'era.",
        remApagadosOk: "Promemoria programmati spenti. La conferma inviata alla creazione di un appuntamento continua a partire.",
        asistenteTitle: "Assistente e dati dell'azienda",
        asistenteDesc: "Configura il nome e il tono dell'assistente e i dati che risponde a {{losPatientPlural}}.",
        asistenteNombre: "Nome dell'assistente",
        asistenteNombrePlaceholder: "Es: SofIA",
        asistenteTono: "Tono",
        tonoCordial: "Cordiale",
        tonoFormal: "Formale",
        tonoInformal: "Informale",
        asistenteInfoEmpresa: "Informazioni sull'azienda",
        asistenteInfoAyuda: "L'assistente usa questi dati per rispondere alle domande (dove siete, orari, {{coberturaPlural}}, ecc.). Ciò che non è qui e non riguarda l'agenda, non lo inventa.",
        infoDireccion: "Indirizzo",
        infoDireccionPlaceholder: "Es: Via Roma 1234, Centro",
        infoTelefono: "Telefono",
        infoTelefonoPlaceholder: "Es: 011-1234567",
        infoHorarios: "Orari di apertura",
        infoHorariosPlaceholder: "Es: Lun-Ven 9-18",
        infoComoLlegar: "Come arrivare",
        infoComoLlegarPlaceholder: "Es: a mezzo isolato dalla piazza, ingresso dal corridoio",
        vocab: {
          title: "Vocabolario",
          desc: "Queste parole si usano in tutto il sistema e anche nei messaggi che invia l'assistente. Si ereditano dal settore; modifica solo ciò che vuoi cambiare.",
          rubroChip: "Settore",
          plural: "Plurale",
          propio: "Valore proprio",
          heredado: "Ereditato",
          restaurar: "Ripristina i valori del settore",
          restaurado: "Vocabolario ripristinato ai valori del settore",
          scheduler: "Chi prenota (accoglienza)",
          room: "Studio / postazione",
          generoTitulo: "il / la",
          generoAyuda: "Indica se la parola è maschile o femminile. Serve perché il sistema scriva bene l'articolo (\"la Filiale\", non \"il Filiale\") in tutte le schermate.",
          generoM: "il",
          generoF: "la",
          patient: "Persona servita",
          professional: "Professionista",
          appointment: "Appuntamento",
          specialty: "Specialità",
          service: "Servizio",
          waitingRoom: "Sala d'attesa",
          cobertura: "Copertura (mutua / assicurazione)",
          patientName: "Campo: Nome",
          patientPhone: "Campo: Telefono",
        },
        infoObrasSociales: "{{coberturaPlural_c}}",
        infoObrasSocialesPlaceholder: "Es: PAMI, OSDE, privato (o 'non lavoriamo con {{cobertura}}')",
        infoFormasPago: "Metodi di pagamento",
        infoFormasPagoPlaceholder: "Es: contanti, bancomat, bonifico",
        infoAdicional: "Informazioni aggiuntive",
        infoAdicionalPlaceholder: "Qualsiasi altro dato che l'assistente deve sapere per rispondere",
        grupoGeneral: "Generale",
        grupoRecordatorios: "Promemoria",
        grupoAgenda: "Agenda",
        grupoPermisos: "Permessi e pannello",
        rwTitle: "Finestra di invio dei promemoria",
        rwDesc: "Fascia oraria e giorni in cui è consentito inviare promemoria.",
        rwInheritedBadge: "Ereditato",
        rwOwnBadge: "Configurazione propria",
        rwInheritedFrom: "Questa azienda usa il default globale di TurnosIA. Valore effettivo:",
        rwEffectivePreview: "Valore effettivo",
        rwHoraDesde: "Ora da",
        rwHoraHasta: "Ora a",
        rwDiasEvitar: "Giorni da evitare",
        rwSabadoHasta: "Sabato fino a",
        rwSabadoPropio: "Sabato con orario proprio",
        rwUsarPropia: "Usa configurazione propria",
        rwVolverHeredar: "Torna a ereditare",
        rwGuardar: "Salva finestra",
        rwHelp: "I promemoria che cadrebbero fuori da questa fascia o in un giorno evitato vengono spostati al momento valido più vicino precedente.",
        rwOkGuardado: "Finestra di invio salvata",
        rwOkHeredar: "Tornata a ereditare il default globale",
        rwDia_dom: "Dom",
        rwDia_lun: "Lun",
        rwDia_mar: "Mar",
        rwDia_mie: "Mer",
        rwDia_jue: "Gio",
        rwDia_vie: "Ven",
        rwDia_sab: "Sab",
        activar: "Attiva",
        configuracionGeneral: "Configurazione generale",
        parametrosDesc: "Parametri di integrazione e comportamento del modulo.",
        urlWebhookN8n: "Webhook n8n (TurnosIA)",
        urlWebhookN8nHelp: "I messaggi che arrivano sulla linea di TurnosIA vengono inviati a questo webhook.",
        webhookConfigured: "Configurato",
        webhookNotConfigured: "Non configurato",
        webhookManagedBySuperadmin: "Gestito dal team (pannello superadmin).",
        guardarConfig: "Salva configurazione",
        secuenciaRecordatorios: "Sequenza promemoria",
        secuenciaDesc: "Quando e quale tipo di messaggio viene inviato prima. Può esserci una sola richiesta di conferma per ogni {{appointment}}.",
        headerOrden: "Ordine",
        headerHorasAntes: "Ore prima",
        headerTipo: "Tipo",
        headerActivo: "Attivo",
        headerAcciones: "Azioni",
        sinPasos: "Nessun passaggio configurato",
        plantillasMensajes: "Modelli di messaggi",
        plantillasDesc: "Testi inviati in ogni situazione. Variabili disponibili:",
        guardarPlantilla: "Salva",
        especialidades: "{{specialtyPlural_c}}",
        especialidadesDesc: "Come si classifica chi riceve. Puoi aggiungere, modificare o disattivare.",
        sinEspecialidades: "Non hai ancora aggiunto {{specialtyPlural}}.",
        cancelarEspecialidad: "Annulla",
        agregarEspecialidad: "Aggiungi {{specialty}}",
        cfTitle: "Campi personalizzati",
        cfDesc: "Campi extra richiesti al caricamento (es. Targa, Note). Li definisce la tua azienda.",
        cfAdd: "Aggiungi campo",
        cfEmpty: "Nessun campo personalizzato configurato",
        cfColLabel: "Etichetta",
        cfColType: "Tipo",
        cfColRequired: "Obbligatorio",
        cfColCalendar: "Nel calendario",
        cfCalendarHelp: "Appare nella scheda dell'appuntamento nel calendario, prima del nome (es. la targa). Massimo 2 campi.",
        cfColOrder: "Ordine",
        cfEdit: "Modifica campo",
        cfNew: "Nuovo campo personalizzato",
        cfKeyLabel: "Chiave (key)",
        cfKeyHelp: "Identificatore stabile, senza spazi. Non modificabile dopo.",
        cfOptionsLabel: "Opzioni (separate da virgola)",
        cfOptionsHelp: "Es: Rosso, Verde, Blu",
        cfErrorLabel: "L'etichetta è obbligatoria",
        cfErrorKey: "La chiave è obbligatoria",
        cfErrorOptions: "Le opzioni sono obbligatorie per il tipo elenco",
        cfType_text: "Testo",
        cfType_textarea: "Testo lungo",
        cfType_number: "Numero",
        cfType_date: "Data",
        cfType_select: "Elenco",
        tplTitle: "Applica modello di settore",
        tplDesc: "Aggiunge specialità, campi e termini del settore scelto. Non sovrascrive ciò che hai già modificato.",
        tplSelectLabel: "Settore",
        tplSelectPlaceholder: "Seleziona...",
        tplApply: "Applica modello",
        tplCurrent: "Settore attuale",
        tplName_generico: "Generico",
        tplName_odontologia: "Odontoiatria",
        tplName_taller: "Officina",
        tplConfirmTitle: "Applicare il modello?",
        tplConfirmBody: "Aggiunge specialità, campi personalizzati e terminologia del settore. Non sovrascrive ciò che hai già modificato.",
        tplAplicada: "Modello applicato",
        outgoingTitle: "Linea di TurnosIA",
        outgoingDesc: "Numero dedicato a TurnosIA. Si usa per inviare i promemoria e per ricevere le conversazioni dell'assistente.",
        outgoingLabel: "Linea di TurnosIA",
        outgoingDefault: "Usa la connessione predefinita",
        outgoingEmpty: "Nessuna connessione WhatsApp in questa azienda.",
        outgoingHint: "Consigliato un numero QR: gli avvisi di TurnosIA sono testo libero.",
        outgoingMetaWarn: "META richiede un modello approvato. Gli avvisi di TurnosIA sono testo libero — scegli un numero QR.",
        lineStatusFree: "Libera",
        lineStatusCurrent: "Linea attuale di TurnosIA",
        lineStatusCompanyBot: "In uso dal bot dell'azienda",
        lineStatusOtherBot: "In uso da un altro bot (webhook proprio)",
        lineOccupiedTitle: "Questa linea è già in uso",
        lineOccupiedCompanyBot: "Questa linea oggi serve il bot dell'azienda. Se la assegni a TurnosIA, i messaggi in entrata non andranno più a quel bot.",
        lineOccupiedOtherBot: "Questa linea oggi è usata da un altro bot (ha un proprio webhook). Se la assegni a TurnosIA, smetterà di ricevere quei messaggi.",
        lineOccupiedConfirm: "Assegna comunque",
        lineOccupiedCancel: "Annulla",
        textoPara: "Testo per",
        salasEspera: "{{waitingRoomPlural_c}}",
        salasDesc: "Gli schermi che vede chi attende. Ognuno può mostrare chi scegli tu.",
        agregarSala: "Aggiungi sala",
        sinSalas: "Nessuna sala configurata.",
        todosProfesionales: "Senza filtro",
        featureNoHabilitada: "Questa funzione non è abilitata per la tua azienda. Contatta l'amministratore per attivarla.",
        templateBookingConfirmed: "Conferma prenotazione",
        templateAppointmentRescheduled: "Avviso di riprogrammazione",
        templateReminder: "Promemoria semplice",
        templateConfirmationRequest: "Richiesta di conferma",
        templateRebalanceOffer: "Offerta di riequilibrio",
        templateWaitinglistOffer: "Offerta dalla lista d'attesa",
        templateCancellationConfirmed: "Avviso di annullamento",
        templateWaitinglistAdded: "Aggiunto alla lista d'attesa",
        templateLlamarSiguiente: "Tocca a te (chiama il prossimo)",
        templateArrivalCheck: "Stai arrivando? (appuntamento iniziato senza arrivo)",
        arrivalTitle: "Verifica di arrivo",
        arrivalHelp: "Se un appuntamento confermato è iniziato da qualche minuto e nessuno ha segnato «Arrivato» in agenda, si chiede al cliente se sta arrivando. Se risponde che è già qui, l'assistente registra l'arrivo. Rispetta l'interruttore dei promemoria programmati.",
        arrivalSwitch: "Chiedere «stai arrivando?»",
        arrivalMinutes: "Minuti dopo l'inizio dell'appuntamento",
        arrivalMinutesHelp: "Tra 5 e 120. Vuoto = 10.",
        arrivalWarn: "⚠ Se la reception non segna «Arrivato», il messaggio può arrivare a chi è già in sede.",
        errorSoloUnaConfirmacion: "Può esserci una sola richiesta di conferma per ogni {{appointment}}.",
        errorNombreRequerido: "Il nome è obbligatorio",
        errorGuardar: "Errore nel salvataggio",
        errorDesactivar: "Impossibile disattivare",
        errorSlugRequerido: "Nome e slug sono obbligatori",
        slugEmpresa: "Identificatore azienda (slug)",
        helperSlug: "Senza spazi o caratteri speciali",
        idDepartamento: "ID dipartimento WAIA",
        helperDepartamento: "Per instradare i ticket a questo dipartimento",
        rebalanceoAuto: "Attiva il riequilibrio automatico alla cancellazione degli appuntamenti",
        tiempoRespuesta: "Tempo di risposta offerta (minuti)",
        helperTiempoRespuesta: "Minuti a disposizione del candidato per accettare un'offerta",
        diasListaEspera: "Giorni in lista d'attesa",
        helperDiasLista: "Giorni in cui si rimane in lista",
        ventanaAdelantamiento: "Finestra di anticipo (giorni)",
        helperVentana: "Giorni in avanti per cercare candidati",
        exclusionCancelar: "Esclusione dopo cancellazione (ore)",
        helperExclusion: "Ore di esclusione anti-loop",
        duracionEsperada: "Durata attesa, in minuti",
        helperDuracion: "Si applica quando la richiesta non indica {{unService}}. Ordine: quella del {{service}} scelto; se non c'è {{service}}, questa; se questa è vuota, 30 minuti. Serve anche a calcolare se si è in anticipo o in ritardo.",
        vrTitle: "Finestra di prenotazione",
        vrDesc: "Fino a quando in avanti si possono dare {{appointmentPlural}}, e da quando può darli l'assistente su WhatsApp.",
        vrTechoLabel: "Con quanto anticipo si può prenotare",
        vrTechoHelp: "Massimo in avanti. Vale sia per il pannello sia per l'assistente. Tra {{min}} e {{max}}.",
        vrUnitLabel: "Unità",
        vrUnitDays: "giorni",
        vrUnitMonths: "mesi",
        vrPisoLabel: "Anticipo minimo (solo su WhatsApp)",
        vrPisoHelp: "I prossimi {{n}} giorni restano riservati a chi telefona o passa in sede; l'assistente non li propone, ma da qui puoi continuare a prenotarli.",
        vrPisoHelpZero: "Nessun minimo: l'assistente può proporre {{appointmentPlural}} anche per oggi. Inserisci un numero di giorni per riservare i primi giorni a chi telefona o passa in sede.",
        vrConfirmSkipLabel: "Non chiedere conferma se prenotato su WhatsApp con meno di N giorni",
        vrConfirmSkipHelp: "Se {{elPatient}} ha prenotato su WhatsApp e mancano meno di {{n}} giorni, non si chiede conferma: l'ha appena scelto. Vuoto = {{n}} giorni.",
        vrConfirmSkipOff: "0 = la conferma si chiede sempre, anche se {{elPatient}} ha prenotato su WhatsApp poco fa.",
        vrBotSlotLimitLabel: "Orari che l'assistente riceve per richiesta",
        vrBotSlotLimitHelp: "L'assistente sceglie tra i primi {{n}} orari di ogni richiesta. Con più sedi, un numero basso si riempie con i primi orari della mattina e il pomeriggio non gli arriva mai. Vuoto = 20.",
        pideConfirmacion: "Richiede conferma",
        recordatorio: "Promemoria",
        si: "Sì",
        no: "No",
        editar: "Modifica",
        eliminar: "Elimina",
        editarEspecialidad: "Modifica {{specialty}}",
        nuevaEspecialidad: "Aggiungi {{specialty}}",
        nombreEspecialidad: "Nome",
        guardarEspecialidad: "Salva",
        activa: "Attiva",
        inactiva: "Inattiva",
        editarNombre: "Modifica nome",
        desactivar: "Disattiva",
        editarSala: "Modifica sala",
        nuevaSala: "Aggiungi {{waitingRoom}}",
        nombreSala: "Nome *",
        slugSala: "Slug *",
        helperSlugSala: "Solo minuscole e trattini. Esempio: sala-principale",
        plantillaVoz: "Modello vocale",
        helperVoz: "Variabili: {nombre} {consultorio} {profesional}",
        guardarSala: "Salva",
        copiarUrl: "Copia URL",
        sinLinkCorto: "Nessun link breve",
        regenerarLink: "Rigenera e copia link breve",
        generarLink: "Genera link breve",
        linkCopiado: "Link copiato",
        errorLink: "Errore nella generazione del link breve",
        editarPaso: "Modifica passaggio",
        agregarPaso: "Aggiungi passaggio",
        horasAntes: "Ore prima",
        tipoRecordatorio: "Tipo",
        activoSwitch: "Attivo",
        guardarPaso: "Salva",
        guardadoOk: "Salvato correttamente",
        permisosProfesional: "Permessi di chi riceve",
        permisosProfesionalDesc: "Cosa può fare sulla propria agenda, dal proprio calendario.",
        professionalCanCreate: "Può caricare {{appointmentPlural}} nella propria agenda",
        professionalCanMove: "Può riprogrammare (spostare o trascinare) i propri",
        panelDeTurno: "Pannello di dettaglio",
        panelDeTurnoDesc: "Quali azioni appaiono aprendo il dettaglio.",
        panelAction: {
          status: "Cambiare stato",
          move: "Spostare",
          reAvisar: "Riavvisare via WhatsApp",
          cancelReason: "Annullare con motivo",
          openChat: "Aprire la chat",
          history: "Cronologia",
          statusLog: "Registro cambi di stato",
          waitingRoom: "Chiamare ({{waitingRoom}})",
          followUp: "Follow-up",
          note: "Note",
          showPhone: "Mostrare telefono",
          delete: "Eliminare",
        },
        localizacion: "Localizzazione",
        localizacionDesc: "Fuso orario e lingua di date/orari per tutta l'azienda.",
        timezone: "Fuso orario",
        locale: "Lingua delle date",
      },
      internalChat: {
        placeholder: "Scrivi un messaggio...",
        para: "A",
        todos: "Tutti",
        chatInterno: "Chat interno",
        mediaTooLarge: "I file superano il limite di 18 MB. Inviane meno alla volta.",
        quotedNotLoaded: "Il messaggio citato non è più caricato in questa conversazione.",
        jumpToQuoted: "Vai al messaggio citato",
      },
      salaEspera: {
        cargando: "Caricamento…",
        errorConexion: "Impossibile connettersi al servizio.",
        fallbackNombre: "{{waitingRoom_c}}",
        enAtencion: "⬤ In visita ora",
        aguardando: "In attesa della chiamata…",
        proximosTurnos: "A seguire",
        sinProximos: "Non c'è nessuno in attesa",
        yaAtendidos: "Già passati",
        sinPrevios: "Oggi non è ancora passato nessuno",
        linkNoEncontrado: "Schermata non trovata",
        llamado: "Chiamato",
        enAtencionCard: "In visita",
        min: "min",
      },
      sidebar: {
        empresas: "Aziende",
        dashboardAdmin: "Dashboard",
        comunicados: "Comunicazioni",
        logsDelSistema: "Log di sistema",
        avisos: "Avvisi",
        apis: "API",
        turnosIA: "TurnosIA",
        citas: "Appuntamenti",
        changelog: "Changelog",
        turnos: "TurnosIA",
        pendientes: "In sospeso",
        estadisticas: "Statistiche",
        reportes: "Report",
        etiquetas: "Etichette",
        estadosDeContacto: "Stati del contatto",
        matchprop: "MatchProp",
        aiServices: "Servizi IA",
        aiStats: "Statistiche IA",
        connectionsOverview: "Connessioni (globale)",
      },
      superAdminConnections: {
        title: "Connessioni per azienda",
        subtitle: "Stato di tutte le connessioni WhatsApp e salute delle linee Meta, in tutte le aziende.",
        refresh: "Aggiorna",
        semaphoreSection: "Semaforo connessioni",
        semaphoreHelp: "Riepilogo per azienda. Verde: tutte connesse. Giallo: in riconnessione o caduta parziale. Rosso: caduta senza connessione attiva. Grigio: nessuna connessione.",
        company: "Azienda",
        state: "Stato",
        total: "Totale",
        connected: "Connesse",
        transitional: "In transizione",
        down: "Cadute",
        lastChange: "Ultima modifica",
        semaphore: {
          green: "Operativa",
          yellow: "Attenzione",
          red: "Caduta",
          none: "Nessuna connessione",
        },
        metaSection: "Linee Meta",
        metaHelp: "Salute di ogni linea WhatsApp Cloud API / Coesistenza.",
        metaEmpty: "Nessuna linea Meta configurata.",
        line: "Linea",
        type: "Tipo",
        coexistence: "Coesistenza",
        phoneNumberId: "Phone Number ID",
        wabaId: "WABA ID",
        status: "Stato",
        health: "Salute",
        historySync: {
          title: "Cronologia",
          attempts: "{{count}} tentativo/i",
          requestedAt: "Collegata: {{date}}",
          nextAt: "Prossimo tentativo: {{date}}",
          lastError: "Ultimo errore: {{error}}",
          notSharedAt: "Avviso di Meta: {{date}}",
          status: {
            pending: "In attesa",
            success: "Richiesta OK",
            failed: "Fallita",
            expired: "Scaduta",
            skipped: "Non richiesta",
            not_shared: "Il cliente non ha condiviso la cronologia",
          },
        },
      },
      superAdminAI: {
        title: "Servizi IA — Configurazione per azienda",
        subtitle: "Abilita Servizi IA per azienda e inserisci le chiavi dei provider (OpenAI, Anthropic, Gemini) come riserva.",
        company: "Azienda",
        selectCompany: "Seleziona azienda",
        enabled: "Abilita Servizi IA",
        enabledHelp: "Attiva la sezione Servizi IA per questa azienda. L'amministratore potrà configurare i servizi e le sue chiavi.",
        keysSection: "Chiavi dei provider (riserva)",
        keysHelp: "Le chiavi dell'amministratore hanno priorità. Queste sono una riserva opzionale.",
        providerEnabled: "abilitato",
        apiKey: "Chiave di {{provider}}",
        keyConfigured: "•••• (configurata)",
        keyNotSet: "Non configurata",
        save: "Salva",
        saveOk: "Configurazione salvata",
        showKey: "Mostra chiave",
        hideKey: "Nascondi chiave",
      },
      aiServices: {
        title: "Servizi IA",
        notEnabled: "Servizi IA non è abilitato per la tua azienda. Contatta l'assistenza.",
        transcriptLabel: "Trascrizione",
        transcribeBtn: "Trascrivi audio",
        transcribing: "Trascrizione in corso…",
        failedMsg: "Impossibile trascrivere",
        retry: "Riprova",
        consumptionWarning: "⚠ I servizi IA consumano token delle tue chiavi. Ogni utilizzo (ad esempio, trascrivere un audio) ha un costo sul tuo account del provider.",
        keysSection: "Chiavi IA",
        keysHelp: "Inserisci le tue chiavi per provider. È la tua spesa: le chiamate vengono addebitate su queste chiavi.",
        apiKey: "Chiave di {{provider}}",
        keyConfigured: "•••• (configurata)",
        keyNotSet: "Non configurata",
        servicesSection: "Servizi",
        provider: "Provider",
        model: "Modello",
        mode: "Modalità",
        modeHuman: "Modalità (assistenza umana)",
        aiAttendedMode: "Assistenza IA",
        aiAttendedSiempre: "Trascrivi sempre",
        aiAttendedNunca: "Non trascrivere mai",
        aiAttendedHelp: "Quando l'IA gestisce la chat, definisce se l'audio viene convertito in testo affinché l'IA lo comprenda.",
        limitSection: "Limite anti-abuso",
        limitHelp: "0 = nessun limite. Si applica solo alla trascrizione automatica; il pulsante manuale non viene mai limitato.",
        maxPerWindow: "Max. audio per contatto",
        windowMinutes: "ogni (minuti)",
        notSupported: "non supporta",
        transcribeProviderTip: "Anthropic non supporta la trascrizione audio. Usa OpenAI o Gemini.",
        modes: {
          auto: "Automatico (sempre)",
          a_pedido: "Su richiesta (manuale)",
          nunca: "Mai",
        },
        transcription: {
          title: "Trascrizione audio",
          help: "Converte gli audio in arrivo in testo. Scegli provider, modello e quando trascrivere.",
        },
        save: "Salva",
        saveOk: "Salvato",
        showKey: "Mostra chiave",
        hideKey: "Nascondi chiave",
      },
      superAIStats: {
        title: "Statistiche per Assistente IA — Configurazione",
        company: "Azienda",
        selectCompany: "Scegli un'azienda",
        enabled: "Modulo abilitato",
        enabledHelp:
          "Se spento, il modulo non appare nel menu admin e non fornisce dati.",
        visibilityTitle: "Visibilità dei pannelli",
        visibilityHelp:
          "Scegli quali pannelli vede il cliente. Non configurabile con il modulo spento.",
        panels: {
          horasAhorradas: "Ore risparmiate",
          cobertura: "Copertura 24/7",
          reclamosATiempo: "Reclami in tempo",
          iaVsHumano: "IA vs umano",
          recomendaciones: "Raccomandazioni",
          embudoKpis: "Imbuto e KPI",
          objetoReclamo: "Oggetto del reclamo",
          tags: "Etichette",
        },
        saveCompany: "Salva azienda",
        saveOk: "Configurazione salvata",
        saving: "Salvataggio…",
        assistantsTitle: "Assistenti",
        noAssistants: "Questa azienda non ha ancora assistenti.",
        catalogName: "Nome nel catalogo",
        displayName: "Nome visibile",
        type: "Tipo",
        types: {
          satisfaccion: "Soddisfazione",
          venta: "Vendita",
          recupero: "Recupero",
        },
        technicalConfig: "Configurazione tecnica",
        tech: {
          humanClosingHour: "Ora chiusura umana",
          humanWorkMarginHours: "Margine lavoro (ore)",
          timeoutHours: "Timeout (ore)",
          sinRespuestaWarnPct: "Soglia senza risposta (0-1)",
          queueRoles: "Ruoli coda (JSON)",
          jsonFieldMap: "Mappa campi (JSON)",
        },
        saveAssistant: "Salva assistente",
        saveAssistantOk: "Assistente salvato",
        invalidJson: "JSON non valido nei ruoli coda o nella mappa campi.",
      },
      superMatchProp: {
        title: "MatchProp — Configurazione per azienda",
        subtitle: "Rilevatore di richieste immobiliari nei gruppi WhatsApp. Configura inventario, LLM e modalità prova per azienda.",
        company: "Azienda",
        selectCompany: "Seleziona azienda",
        enabled: "Abilita MatchProp",
        enabledHelp: "Attiva il monitoraggio dei gruppi e la generazione di avvisi per questa azienda.",
        dryRun: "Modalità prova (dry-run)",
        dryRunHelp: "In prova, gli avvisi appaiono con badge PROVA e non si considerano invii reali.",
        llmSection: "Modello linguistico (LLM)",
        llmProvider: "Provider",
        llmModel: "Modello",
        llmKey: "API key del LLM",
        inventorySection: "Inventario",
        inventorySource: "Fonte dell'inventario",
        tokkoKey: "API key di Tokko",
        gvaId: "ID Agenzia (GVA)",
        gvaToken: "Token GVA",
        gvaHelp: "La credenziale GVA (ID + token) è fornita dal provider, non dal cliente.",
        ttlMinutes: "TTL inventario (minuti)",
        keyConfigured: "•••• (configurata)",
        keyNotSet: "Non configurata",
        lastSync: "Ultima sincronizzazione",
        save: "Salva",
        forceSync: "Forza aggiornamento ora",
        saveOk: "Configurazione salvata",
        syncOk: "Sincronizzate {{count}} proprietà",
        showKey: "Mostra chiave",
        hideKey: "Nascondi chiave",
      },
      matchpropAdmin: {
        title: "MatchProp",
        notEnabled: "MatchProp non è abilitato per la tua azienda. Contatta il supporto.",
        groupsSection: "Gruppi da monitorare",
        groupsHelp: "Scegli quali gruppi MatchProp deve analizzare in cerca di richieste.",
        noGroups: "Nessun gruppo WhatsApp conosciuto al momento.",
        groupOn: "Gruppo attivato",
        groupOff: "Gruppo disattivato",
        tolerancesSection: "Tolleranze di corrispondenza",
        dormsPlus: "Camere in più accettate",
        dormsPlusHelp: "Accetta immobili con fino a X camere in PIÙ rispetto alla richiesta.",
        dormsMinus: "Camere in meno accettate",
        dormsMinusHelp: "Accetta immobili con fino a X camere in MENO rispetto alla richiesta.",
        precioMargin: "Margine di prezzo (%)",
        precioMarginHelp: "Accetta immobili fino al X% sopra il budget.",
        topN: "Corrispondenze per avviso",
        topNHelp: "Quante corrispondenze mostrare in ogni avviso.",
        minTopLevel: "Livello minimo per avvisare",
        minTopLevelHelp: "ESATTO avvisa solo corrispondenze esatte; SIMILE include quelle approssimative.",
        levelExact: "ESATTO",
        levelSimilar: "SIMILE",
        save: "Salva",
        saveOk: "Salvato",
        aiSection: "Intelligenza Artificiale",
        llmProvider: "Provider IA",
        llmModel: "Modello",
        llmKey: "API key IA",
        comingSoon: "prossimamente",
        sourceSection: "Fonte dell'inventario",
        sourceLabel: "Fonte",
        sourceNotSet: "Il tuo provider non ha ancora configurato la fonte dell'inventario.",
        crmKey: "API key del CRM",
        gvaId: "ID Agenzia (GVA)",
        gvaToken: "Token GVA",
        gvaHelp: "Credenziale fornita da GVA.",
        keyConfigured: "•••• (configurata)",
        keyNotSet: "Non configurata",
        showKey: "Mostra chiave",
        hideKey: "Nascondi chiave",
        consumptionWarning: "⚠ Attiva MatchProp solo nei gruppi di RICHIESTE di immobili. Ogni messaggio di un gruppo monitorato viene analizzato con l'IA e consuma token della tua API. Attivare gruppi che non sono di richieste genera spesa inutile.",
        confirmTitle: "Conferma monitoraggio del gruppo",
        confirmBody: "Il gruppo \"{{group}}\" sarà analizzato con l'IA a ogni messaggio, consumando i tuoi token. Confermi?",
        cancel: "Annulla",
        confirm: "Attiva",
      },
      tags: {
        titulo: "Etichette",
        nueva: "Nuova etichetta",
        creada: "Etichetta creata",
        eliminada: "Etichetta eliminata",
        nombre: "Nome",
        color: "Colore",
        vistaPrevia: "Anteprima",
        cancelar: "Annulla",
        crear: "Crea",
        headerColor: "Colore",
        headerNombre: "Nome",
        headerAcciones: "Azioni",
        sinEtiquetas: "Nessuna etichetta",
      },
      stats: {
        titulo: "Statistiche e ROI",
        ticketsHoy: "Ticket oggi",
        ticketsSemana: "Ticket questa settimana",
        ticketesMes: "Ticket questo mese",
        tiempoRespuesta: "Tempo di risposta medio",
        impactoIA: "Impatto dell'IA questo mese",
        horasAhorradas: "{{hours}} ore risparmiate",
        equivalente: "Equivalente a {{days}} giorni di lavoro · {{ai}} messaggi risposti dall'IA vs {{human}} dagli umani",
        conversacionesPorDia: "Conversazioni al giorno (ultimi 30 giorni)",
        mensajesIAvsHumano: "Messaggi: IA vs Umano",
        sinDatos: "Nessun dato ancora",
        tickets: "Ticket",
        fecha: "Data",
        ia: "IA",
        humano: "Umano",
      },
      contactStates: {
        titulo: "Stati Contatto — Admin",
        estadosContacto: "Stati Contatto",
        agregarEstado: "Aggiungi stato",
        motivosPerdida: "Motivi di Perdita",
        agregarMotivo: "Aggiungi motivo",
        noHayMotivos: "Nessun motivo di perdita. Aggiungine uno per farlo apparire quando si contrassegna un contatto come Perso.",
        cierreAutomatico: "Chiusura Automatica dei Ticket",
        cerrarGanado: "Chiudi ticket quando contrassegnato come Vinto",
        descCerrarGanado: "Quando un contatto viene contrassegnato come Vinto, il ticket attivo si chiude automaticamente.",
        cerrarPerdido: "Chiudi ticket quando contrassegnato come Perso",
        descCerrarPerdido: "Quando un contatto viene contrassegnato come Perso, il ticket attivo si chiude automaticamente.",
        guardarConfig: "Salva configurazione",
        sistema: "Sistema",
        desactivar: "Disattiva",
        activar: "Attiva",
        subir: "Su",
        bajar: "Giù",
        editar: "Modifica",
        eliminar: "Elimina",
        noEliminarSistema: "Non è possibile eliminare uno stato di sistema",
        ocultarSistema: "Stato di sistema. Puoi nasconderlo ma non eliminarlo.",
        editarEstado: "Modifica stato",
        nuevoEstado: "Nuovo stato",
        editarMotivo: "Modifica motivo",
        nuevoMotivo: "Nuovo motivo di perdita",
        nombre: "Nome",
        cancelar: "Annulla",
        guardar: "Salva",
        nombreObligatorio: "Il nome è obbligatorio",
        estadoActualizado: "Stato aggiornato",
        estadoCreado: "Stato creato",
        estadoEliminado: "Stato eliminato. I contatti assegnati rimarranno senza stato.",
        motivoActualizado: "Motivo aggiornato",
        motivoCreado: "Motivo creato",
        motivoEliminado: "Motivo eliminato",
        configuracionGuardada: "Configurazione salvata",
        confirmarEliminacion: "Conferma eliminazione",
        eliminarEstado: "Eliminare questo stato? I contatti con questo stato rimarranno senza stato assegnato.",
        eliminarMotivo: "Eliminare questo motivo di perdita?",
      },
      pendingDashboard: {
        titulo: "Dashboard In Sospeso",
        actualizar: "Aggiorna",
        actualizadoAt: "Aggiornato {{hora}}",
        mios: "Miei",
        vencidos: "Scaduti",
        hoy: "Oggi",
        proximos7d: "Prossimi 7g",
        sinFecha: "Senza data",
        totalActivos: "Totale attivi",
        ver: "Mostra",
        soloMios: "Solo miei",
        miEquipo: "Il mio team",
        todos: "Tutti",
        asesor: "Consulente",
        motivo: "Motivo",
        limpiarFiltros: "Azzera filtri",
        sinPendientesGrupo: "Nessun elemento in sospeso in questo gruppo",
        sinAsignar: "Non assegnato — team",
        asignadoA: "Assegnato a: {{name}}",
        ultimaAccion: "Ultima azione: {{name}} · {{date}}",
        tomar: "Prendi",
        reprogramar: "Riprogramma",
        resolver: "Risolvi",
        chat: "Chat",
        asignarmeEste: "Assegna a me",
        marcarResuelto: "Segna come risolto",
        irAlChat: "Vai alla chat",
        pendienteResuelto: "In sospeso risolto",
        pendienteReprogramado: "In sospeso riprogrammato",
        pendienteAsignado: "In sospeso assegnato a te",
        reprogramarTitulo: "Riprogramma elemento in sospeso",
        cuando: "Quando?",
        fechaYHora: "Data e ora",
        cancelar: "Annulla",
        guardar: "Salva",
        sinFechaChip: "senza data",
        sinResponsable: "senza responsabile",
        vencidoText: "scaduto",
        venceText: "scade",
        hoyText: "oggi",
        proximos7dias: "Prossimi 7 giorni",
        sinFechaGrupo: "Senza data",
      },
      reports: {
        titulo: "Report",
        desde: "Da",
        hasta: "A",
        agente: "Agente",
        todos: "Tutti",
        cola: "Coda",
        todas: "Tutte",
        motivoContacto: "Motivo di contatto",
        generar: "Genera",
        exportarCSV: "Esporta CSV",
        totalChats: "Totale chat",
        cerrados: "Chiusi",
        enAtencion: "In gestione",
        esperando: "In attesa",
        sinRespuesta: "Senza risposta",
        respPromedio: "Risp. media",
        chatsPorDia: "Chat al giorno",
        chats: "Chat",
        fecha: "Data",
        estadoChats: "Stato delle chat",
        sinDatos: "Nessun dato",
        chatsPorAgente: "Chat per agente",
        chatsPorCola: "Chat per coda",
        pctTotal: "% del totale",
        chatsPorMotivo: "Chat per motivo di contatto",
        motivo: "Motivo",
        ia: "IA",
        humano: "Umano",
        abiertos: "Aperti",
        pendientes: "In sospeso",
        mensajesIAvsHumano: "Messaggi: IA vs Umano",
      },
      contacts: {
        title: "Contatti",
        toasts: { deleted: "Contatto eliminato con successo!" },
        searchPlaceholder: "Cerca...",
        confirmationModal: {
          deleteTitle: "Elimina",
          importTitlte: "Importa contatti",
          deleteMessage: "Sei sicuro di voler eliminare questo contatto? Tutte le chat correlate andranno perse.",
          importMessage: "Vuoi importare tutti i contatti dal telefono?",
        },
        buttons: {
          import: "Importa contatti",
          add: "Aggiungi contatto",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Azioni",
        },
        tabContactos: "Contatti",
        tabClientes: "Contatti",
        tabPendientes: "In sospeso",
        tabDescartados: "Scartati",
        tabTodos: "Tutti",
        colNombreWA: "Nome WhatsApp",
        colTipoCliente: "Tipo cliente",
        colNumero: "Numero",
        colEmpresa: "Azienda",
        colNotas: "Note",
        colAtendidoPor: "Gestito da",
        colTotalChats: "Totale chat",
        colUltimaActividad: "Ultima attività",
        sinNombre: "Senza nome",
        moveTo_qualified: "Contatti",
        moveTo_pending: "In sospeso",
        moveTo_disqualified: "Scartati",
        movedToast: "Contatto spostato a {{tab}}",
        undoButton: "Annulla",
        menuMoveTo_qualified: "Sposta in Contatti",
        menuMoveTo_pending: "Sposta in In sospeso",
        menuMoveTo_disqualified: "Sposta in Scartati",
        importando: "Importazione contatti in corso...",
        importOk: "Importati {{imported}} contatti. {{skipped}} già esistevano.",
        importDone: "Importazione completata.",
      },
      queueModal: {
        title: { add: "Aggiungi coda", edit: "Modifica coda" },
        form: { name: "Nome", color: "Colore", greetingMessage: "Messaggio di benvenuto" },
        buttons: { okAdd: "Aggiungi", okEdit: "Salva", cancel: "Annulla" },
        signatureRule: "Regola di firma",
      },
      userModal: {
        title: { add: "Aggiungi utente", edit: "Modifica utente" },
        form: { name: "Nome", email: "Email", password: "Password", profile: "Profilo", whatsapp: "Connessione predefinita", canSeeUnassigned: "Vedere chat non assegnate", allowedWhatsapps: "Connessioni consentite", allowedWhatsappsAll: "Tutte le connessioni", allowedWhatsappsHelp: "Se non ne selezioni nessuna, l'utente vedrà le chat di tutte le connessioni." },
        buttons: { okAdd: "Aggiungi", okEdit: "Salva", cancel: "Annulla" },
        success: "Utente salvato con successo.",
        signatureSectionTitle: "Firma dei messaggi",
        signatureEnabledLabel: "Abilita firma personale",
        signatureNameLabel: "Nome da mostrare nella firma (opzionale)",
        signatureNameHelp: "Se vuoto, viene usato il tuo nome utente normale.",
        showName: "Includi nome",
        showDepartment: "Includi reparto (coda del ticket)",
        showCompany: "Includi azienda",
        signaturePreviewLabel: "Anteprima:",
        signaturePreviewDept: "[Reparto]",
        signaturePreviewCompany: "[Azienda]",
        signaturePreviewEmpty: "(nessun componente selezionato — equivale a non firmare)",
        signaturePreviewDisabled: "(firma disattivata)",
        signatureSanitizedWarning: "Caratteri speciali (* _ ~ `) sono stati rimossi dalla tua firma. Questi caratteri rompono il formato e non sono ammessi.",
        chipsVisibility: {
          title: "Statistiche e dati del ticket",
          subtitle: "Mostra o nascondi le informazioni che appaiono in ogni ticket della lista",
          attentionTime: {
            label: "Tempo di risposta (TDR)",
            tooltip: "Tempo che il cliente sta aspettando la nostra risposta",
          },
          clientSilence: {
            label: "Tempo senza risposta del cliente",
            tooltip: "Tempo dalla nostra ultima risposta senza che il cliente scriva di nuovo",
          },
          ticketAge: {
            label: "Anzianità del ticket",
            tooltip: "Tempo totale da quando il ticket è aperto",
          },
          expiration: {
            label: "Scadenza",
            tooltip: "Ticket prossimi alla chiusura automatica",
          },
          contactState: {
            label: "Stato del contatto",
            tooltip: "Stato commerciale del contatto (Nuovo, Vinto, Cliente, ecc.)",
          },
          whatsappLine: {
            label: "Linea WhatsApp",
            tooltip: "Connessione WhatsApp da cui è arrivato il ticket",
          },
          contactType: {
            label: "Tipo di cliente",
            tooltip: "Categoria assegnata al contatto",
          },
          queue: {
            label: "Reparto",
            tooltip: "Coda o reparto assegnato al ticket",
          },
          tags: {
            label: "Etichette",
            tooltip: "Etichette applicate al ticket",
          },
        },
      },
      chatConnectionBar: {
        windowOpen: "Finestra aperta",
        closesIn: "si chiude tra {{time}}",
        windowClosed: "Finestra chiusa",
      },
      messagesInput: {
        placeholderOpen: "Scrivi un messaggio o premi '/' per usare le risposte rapide",
        placeholderClosed: "Riapri o accetta questo ticket per inviare un messaggio.",
        metaWindowClosedPlaceholder: "Finestra di 24h chiusa — inizia con un template per scrivergli.",
        signMessage: "Firma",
        includeName: "Includi nome",
        captionPlaceholder: "Aggiungi un commento...",
        cancelMedia: "Annulla",
        sendMedia: "Invia",
        dropFileHere: "Rilascia il file qui",
        lockReason: {
          company_disabled: "La firma è disabilitata nelle impostazioni aziendali.",
          contact_forced: "Questo contatto è configurato per firmare sempre.",
          contact_blocked: "Questo contatto è configurato per non firmare mai.",
          type_forced: "Il tipo di cliente è configurato per firmare sempre.",
          type_blocked: "Il tipo di cliente è configurato per non firmare mai.",
          queue_forced: "La coda del ticket è configurata per firmare sempre.",
          queue_blocked: "La coda del ticket è configurata per non firmare mai.",
        },
      },
      scheduledMessages: {
        mode_button: "Programma invio",
        queue_hint: "Messaggi in coda",
        max_reached: "Massimo 4 messaggi per invio programmato",
        pick_datetime: "Quando inviare?",
        send_anyway_label: "Invia anche se il contatto risponde",
        badge: "Programmato per {{datetime}}",
        cancelled_reply: "Invio programmato annullato: il contatto ha risposto",
        cancelled_manual: "Invio programmato annullato",
        cancel_action: "Annulla messaggio programmato",
        sent_ok: "Messaggio programmato inviato",
        send_failed: "Impossibile inviare il messaggio programmato",
        cancel: "Annulla",
        invalid_past: "Data e ora devono essere future",
        was_scheduled: "Inviato come messaggio programmato",
        sending: "Invio in corso…",
        trace_by: "Programmato da {{name}}",
        trace_anon: "Programmato",
        trace_for: "per {{datetime}}",
        event_cancelled_manual: "Invio programmato annullato dall'operatore",
        event_cancelled_reply: "Invio programmato annullato: il contatto ha risposto",
        event_cancelled_closed: "Invio programmato annullato: il ticket è stato chiuso",
        event_cancelled_notfound: "Invio programmato annullato: il ticket non esiste più",
        event_failed: "Impossibile inviare il messaggio programmato",
        event_failed_window: "Impossibile inviare: la finestra di 24 h è scaduta",
        event_failed_partial: "{{sent}} di {{total}} inviati — il resto non è stato inviato",
      },
      signatureOnboarding: {
        message: "La tua azienda ha le firme dei messaggi abilitate. Configura la tua firma personale per identificarti meglio con i tuoi clienti.",
        configure: "Configura",
        dismiss: "Ignora",
      },
      contactModal: {
        title: { add: "Aggiungi contatto", edit: "Modifica contatto" },
        form: {
          mainInfo: "Dati del contatto",
          extraInfo: "Informazioni aggiuntive",
          name: "Nome",
          number: "Numero WhatsApp",
          numberHelp: "Solo numeri con prefisso internazionale. Es: 5493513456789",
          numberOnlyDigits: "Sono ammessi solo numeri.",
          email: "Email",
          extraName: "Nome del campo",
          extraValue: "Valore",
          lastName: "Cognome",
          whatsappName: "Nome WhatsApp",
          company: "Azienda",
          kind: "Tipo cliente",
          notes: "Note",
        },
        buttons: {
          addExtraInfo: "Aggiungi informazione",
          okAdd: "Aggiungi",
          okEdit: "Salva",
          cancel: "Annulla",
        },
        success: "Contatto salvato con successo.",
        statusSection: "Stato del contatto",
        moveTo_qualified: "Contatti",
        moveTo_pending: "In sospeso",
        moveTo_disqualified: "Scartati",
        movedToast: "Contatto spostato a {{tab}}",
        signatureMode: "Modalità firma",
        signatureModeDefault: "Predefinito (decidono utente o regole di tipo)",
        signatureModeAlways: "Firma sempre con questo contatto",
        signatureModeNever: "Non firmare mai con questo contatto",
      },
      contactTypeModal: {
        title: "Modifica tipo di cliente",
        name: "Nome",
        color: "Colore",
        signatureRule: "Regola di firma",
        cancel: "Annulla",
        save: "Salva",
        savedOk: "Tipo di cliente aggiornato",
        errNameRequired: "Il nome è obbligatorio",
      },
      deleteMessageModal: {
        title: "Vuoi eliminare questo messaggio?",
        forEveryone: "Elimina per tutti",
        forMe: "Elimina per me",
        cancel: "Annulla",
        revokeFallbackToast: "Il messaggio non è stato eliminato per tutti. È stato eliminato solo per te.",
      },
      settingsExtra: {
        // feat_347 — labels de los 8 tabs de /Settings
        // feat_352 — se fue `tabIa` (el tab se fusionó en automatizaciones) y entró
        // `tabReporteEmail`. Siguen siendo 8.
        tabNegocio: "Azienda",
        tabBandeja: "Posta in arrivo",
        tabMensajes: "Messaggi",
        tabAutomatizaciones: "Automazioni",
        tabReporteEmail: "Report via email",
        tabClasificacion: "Classificazione",
        tabIntegraciones: "Integrazioni e API",
        tabPermisos: "Permessi",
        // feat_351 — tab Permisos restyleado con el patrón visual canónico
        permisosSectionTitle: "Permessi degli operatori",
        permisosSectionHelp: "Scegli cosa può fare nelle chat un operatore, cioè qualsiasi utente che non sia amministratore. Gli amministratori hanno sempre tutti i permessi.",
        permisosDeleteChatLabel: "Consentire di eliminare le chat",
        permisosDeleteChatHelp: "L'operatore può eliminare un'intera chat dal menu della chat.",
        permisosDeleteChatTooltip: "Elimina l'intera chat, con tutti i suoi messaggi, per tutta l'azienda. Non è reversibile.",
        permisosDeleteMessageLabel: "Consentire di eliminare i messaggi",
        permisosDeleteMessageHelp: "L'operatore può eliminare singoli messaggi all'interno di una chat.",
        permisosDeleteMessageTooltip: "Elimina un messaggio dalla cronologia della chat. Se lo ha inviato l'azienda e WhatsApp lo consente ancora, viene proposto di eliminarlo anche per il cliente.",
        moreInfoAriaLabel: "Maggiori informazioni",
        // feat_339 — gate de carga de la página de Ajustes
        loadingSettings: "Caricamento…",
        identidadAsistente: "Identità dell'Assistente",
        // feat_353 — restyle del tab Negocio con el patrón de feat_351
        negocioIdentidadHelp: "Come si presenta l'IA e con quali dati parla della tua azienda.",
        negocioSedeLabel1: "Sede 1",
        negocioSedePh1: "Es: Centrale (Via Roma 346)",
        negocioSedeLabel2: "Sede 2",
        negocioSedePh2: "Es: Filiale Nord",
        negocioHorarioHelp: "Base oraria usata dal carrello abbandonato e dagli altri automatismi.",
        negocioAlways247Help: "L'azienda è considerata sempre disponibile.",
        negocioFeriadosHelp: "Giorni in cui l'azienda non è operativa, anche se l'orario dice di sì.",
        nombreNegocio: "Nome dell'azienda",
        phNombreNegocio: "Es: Studio Dentistico Gazzera",
        nombreAsistente: "Nome dell'assistente virtuale",
        phNombreAsistente: "Es: Lucia",
        idioma: "Lingua",
        tonoAsistente: "Tono dell'assistente",
        tokenAPI: "Token API",
        usarTokenDesc: "Usa questo token per connettere WAIA con sistemi esterni.",
        ocultarToken: "Nascondi token",
        mostrarToken: "Mostra token",
        copiarToken: "Copia token",
        tokenCopiado: "Token copiato",
        integracionIA: "Integrazione / IA",
        guardarConfig: "Salva configurazione",
        iaHabilitada: "IA abilitata",
        vendedorIA: "Venditore IA",
        activo: "Attivo",
        inactivo: "Inattivo",
        deshabilitadoAdmin: "Disabilitato dall'amministratore",
        automatizacionTickets: "Automazione ticket",
        escenario1: "Scenario 1: Carrello abbandonato",
        descEscenario1: "Il consulente o l'IA hanno inviato l'ultimo messaggio, ma il cliente non ha risposto. L'IA viene notificata via webhook per il follow-up.",
        escenario2: "Scenario 2: Senza risposta",
        descEscenario2: "Il cliente ha inviato l'ultimo messaggio ma il team non ha risposto. Viene aggiunta una nota interna al ticket per avvisare il consulente assegnato.",
        escenario3: "Scenario 3: Ticket dimenticato",
        descEscenario3: "Il consulente o l'IA hanno inviato l'ultimo messaggio, il ticket ha un consulente assegnato ed è rimasto aperto troppo a lungo. Il ticket viene chiuso automaticamente con una nota interna.",
        activar: "Attiva",
        umbralHoras: "Soglia di inattività (ore)",
        rec4h: "Consigliato: 4 ore",
        rec2h: "Consigliato: 2 ore",
        rec24h: "Consigliato: 24 ore",
        configClasica: "Configurazione classica (chiusura per inattività generale)",
        activarResolucion: "Attiva risoluzione automatica per inattività",
        resolverEn: "Risolvi in (ore di inattività)",
        ticketsSinActividad: "I ticket senza attività per questo tempo saranno chiusi",
        notificarCliente: "Notifica il cliente (minuti prima della chiusura)",
        sinNotificacion: "0 = nessuna notifica prima della chiusura",
        mensajeDespedida: "Messaggio di chiusura al cliente",
        phMensajeDespedida: "Ciao, la tua richiesta è stata chiusa per inattività. Puoi scriverci quando vuoi.",
        enviarAnteCierre: "Viene inviato al cliente prima di chiudere il ticket",
        notificarIA: "Notifica il sistema IA alla chiusura (per prendere contesto)",
        continuidadConversacion: "Continuità della conversazione",
        descContinuidad: "Definisci quanti giorni dopo la chiusura di un ticket può essere riaperto se il cliente torna a scrivere. Con 0 giorni, la conversazione non si frammenta mai: è sempre lo stesso ticket.",
        diasReapertura: "Giorni di riapertura",
        tdrTitle: "Semaforo Tempo di Risposta (TDR)",
        tdrDesc: "Definisce le soglie di allerta per il tempo di attesa del cliente. L'indicatore cambia colore in base al tempo trascorso dall'ultimo messaggio del cliente senza risposta del team.",
        tdrAmarilla: "Allerta gialla (minuti)",
        tdrAmarillaDesc: "L'indicatore diventa giallo quando il cliente aspetta da questo tempo senza risposta.",
        tdrRoja: "Allerta rossa (minuti)",
        tdrRojaDesc: "L'indicatore diventa rosso quando il cliente aspetta da questo tempo senza risposta.",
        tdrWarning: "⚠️ La soglia gialla deve essere minore di quella rossa.",
        tiposCliente: "Tipi di Cliente",
        nombreTipo: "Nome del tipo",
        sinTipos: "Nessun tipo definito",
        agregar: "Aggiungi",
        motivosContacto: "Motivi di Contatto",
        nombreMotivo: "Nome del motivo",
        sinMotivos: "Nessun motivo definito",
        copiar: "Copia",
        copiado: "Copiato!",
        urlAutomatizacion: "URL di Automazione",
        tokenAutomatizacion: "Token di Automazione",
        timeoutSegundos: "Timeout (secondi)",
        reintentos: "Tentativi",
        promptAsistente: "Prompt dell'Assistente",
        firmaTitle: "Firma dei messaggi",
        firmaEnabledLabel: "Abilita firma per questa azienda",
        firmaEnabledHelp: "Quando attivo, gli utenti possono firmare i loro messaggi in uscita con il loro nome, dipartimento e/o azienda. Ogni utente configura la propria firma nel proprio profilo.",
        firmaReglaNoneOption: "Nessuna regola (decide l'utente)",
        firmaReglaAlwaysOption: "Firma sempre",
        firmaReglaNeverOption: "Non firmare mai",
        firmaReglaPreferOnOption: "Suggerisci di firmare (switch ON di default)",
        firmaReglaPreferOffOption: "Suggerisci di non firmare (switch OFF di default)",
        firmaQuoteLabel: "Stile citazione per la firma",
        firmaQuoteHelp: "Se attivo, la firma viene inviata come blocco citazione WhatsApp (verde indentato) per distinguersi dal messaggio.",
        inboxModeSectionTitle: "Modalità casella di posta",
        inboxModeLabel: "Modalità casella di posta",
        inboxModeHelper: "Unificato mostra IN GESTIONE e IN ATTESA in un'unica lista ordinata per attività.",
        inboxModeSplit: "Separato (due sub-tab)",
        inboxModeUnified: "Unificato (stile WhatsApp)",
        inboxOpenCount: "In gestione",
        inboxPendingCount: "In attesa",
        inboxOpenTooltip: "Chat con un consulente assegnato",
        inboxPendingTooltip: "Chat in attesa di essere gestite",
        inboxModeSmart: "Intelligente (orfani in Attesa)",
        inboxSmartAttendingTooltip: "Chat in gestione + assegnati dall'IA",
        inboxSmartWaitingTooltip: "Chat senza reparto assegnato — richiedono attenzione umana",
        inboxSortLabel: "Ordine",
        inboxSortChrono: "Cronologico",
        inboxSortUrgent: "Urgenti prima",
        inboxUnansweredLabel: "Senza risposta",
        inboxUnansweredTooltip: "Mostra solo le chat dove il cliente ha scritto e nessuno ha ancora risposto",
        inboxUnansweredActive: "Filtro attivo: senza risposta",
        cancelScheduledOnReplyLabel: "Annulla messaggi programmati se il contatto risponde",
        markReadOnOpenSectionTitle: "Lettura dei messaggi",
        markReadOnOpenLabel: "Segna come letto all'apertura della chat",
        markReadOnOpenHelper: "Se attivo, i messaggi vengono segnati come letti non appena l'operatore apre la chat. Se disattivato, vengono segnati solo quando si invia una risposta.",
        showUserFilterSectionTitle: "Filtro per utente nella lista ticket",
        showUserFilterLabel: "Mostra filtro per utente (solo admin)",
        showUserFilterHelper: "Permette agli admin di filtrare la lista ticket per uno o più agenti assegnati.",
        attendingModeSectionTitle: "In gestione da (indicatore e blocco)",
        attendingModeLabel: "Modalità",
        attendingModeOff: "Nessun indicatore",
        attendingModeVisual: "Mostra chi sta gestendo",
        attendingModeLock: "Mostra e blocca la scrittura altrui",
        attendingModeHelper: "\"Mostra chi sta gestendo\" aggiunge un indicatore \"IN GESTIONE DA\" nell'intestazione e nell'elenco quando un ticket aperto è di un altro operatore. \"Blocca la scrittura altrui\" impedisce anche di scrivere in quel ticket. Il proprietario del ticket e gli amministratori possono sempre scrivere; i ticket in attesa non assegnati restano liberi.",
        closedPooledSectionTitle: "Risolti condivisi (chi può riprenderli)",
        closedPooledLabel: "Modalità",
        closedPooledOff: "Isolato (ognuno vede i propri)",
        closedPooledQueue: "Risolti condivisi per coda",
        closedPooledCompany: "Risolti condivisi in tutta l'azienda",
        closedPooledHelper: "Una conversazione risolta resta nei Risolti di chi l'ha risolta. Questa modalità decide chi ALTRO può trovarla con la ricerca e riprenderla: nessuno (isolato), gli operatori della stessa coda, oppure chiunque in azienda. Riprendendola passa a IN GESTIONE, viene assegnata a chi l'ha presa e spostata nella sua coda. Mentre la gestisce una persona, l'IA non risponde.",
        // feat_339 — desglose por modo, debajo de la intro de arriba
        closedPooledHelperOff: "Nessun altro la vede. Ogni operatore trova soltanto le conversazioni che ha risolto lui.",
        closedPooledHelperQueue: "La vedono gli operatori che condividono quella coda. Riprendendola, passa alla coda di chi l’ha presa.",
        closedPooledHelperCompany: "La vede chiunque in azienda, indipendentemente dalla coda. Ideale se un cliente torna e lo gestisce chi è libero.",
        // feat_343 — Resolver directo (cierra sin preguntar en qué quedó)
        directResolveSectionTitle: "Risoluzione diretta",
        directResolveLabel: "Risolvendo una conversazione, chiuderla subito — senza chiedere com'è andata",
        directResolveHelper: "Con l'interruttore spento, toccando Risolvi viene chiesto se il contatto è stato vinto o perso. Con l'interruttore acceso, Risolvi chiude subito la conversazione e lo stato del contatto resta com'è.",
        outboundTypingSectionTitle: "Indicatore \"sta scrivendo...\"",
        outboundTypingLabel: "Mostra \"sta scrivendo...\" / \"registrando audio...\" al contatto",
        outboundTypingHelp: "Quando un operatore scrive o registra un audio, il contatto lo vede sul suo telefono (come WhatsApp). Solo connessioni compatibili; Meta solo \"sta scrivendo\" e richiede un messaggio recente del contatto.",
        outboundTypingAiLabel: "Mostra \"sta scrivendo...\" quando risponde l'IA",
        outboundTypingAiHelp: "Mentre l'intelligenza artificiale genera una risposta, il contatto vede \"sta scrivendo...\" sul suo telefono. Rende l'attesa più naturale.",
        autoReplyMediaSectionTitle: "Risposta automatica ai media",
        autoReplyMediaEnabledLabel: "Invia una scusa quando arrivano audio, video, immagini o documenti",
        autoReplyMediaEnabledHelp: "Quando attivo, l'IA non elabora il media e viene inviato un singolo messaggio di cortesia dopo un breve debounce.",
        autoReplyMediaScopeLabel: "Quando rispondere",
        autoReplyMediaScopeAiOnly: "Solo quando l'IA dovrebbe rispondere",
        autoReplyMediaScopeAlways: "Sempre (anche se un operatore sta gestendo il ticket)",
        autoReplyMediaTypesLabel: "Comportamento per tipo di media",
        autoReplyMediaTypeAudio: "Audio (vocali e allegati)",
        autoReplyMediaTypeVideo: "Video",
        autoReplyMediaTypeImage: "Immagini",
        autoReplyMediaTypeDocument: "Documenti",
        autoReplyMediaTextAudio: "Testo per audio",
        autoReplyMediaTextVideo: "Testo per video",
        autoReplyMediaTextImage: "Testo per immagini",
        autoReplyMediaTextDocument: "Testo per documenti",
        autoReplyMediaTypeSticker: "Sticker",
        autoReplyMediaTypeReaction: "Reazioni (emoji e 👍)",
        autoReplyMediaTextSticker: "Testo per gli sticker",
        autoReplyMediaTextReaction: "Testo per le reazioni",
        autoReplyMediaActionLabel: "Comportamento",
        autoReplyMediaActionAi: "Passa all'IA",
        autoReplyMediaActionIgnore: "Ignora",
        autoReplyMediaActionReply: "Rispondi con testo",
        autoReplyMediaReactionHelp: "Le reazioni (👍 ❤️ ecc.) vengono passate all'IA come testo. L'IA le interpreta come conferme o risposte.",
        autoReplyMediaTextGeneric: "Testo generico (usato quando arrivano più tipi insieme)",
        autoReplyMediaTextPlaceholder: "Lascia vuoto per usare il testo predefinito nella lingua dell'azienda.",
        autoReplyMediaTimeoutLabel: "Debounce (secondi)",
        autoReplyMediaTimeoutHelp: "Tempo di attesa dopo l'ultimo audio/video/immagine/doc prima di inviare la risposta. Suggerito: 60.",
        emailReportSectionTitle: "📧 Report via email",
        emailReportSectionDesc: "Quando una coda rimane senza risposta per il tempo configurato, il sistema invia un'email di report al destinatario configurato.",
        emailReportQueues: "Code di attivazione",
        emailReportQueuesHelp: "Il report viene inviato quando un ticket di queste code è inattivo per il tempo configurato.",
        emailReportRecipients: "Destinatari del report",
        emailReportRecipientsHelp: "Separare con virgole. Es: admin@azienda.com, supporto@azienda.com",
        emailReportTimeoutHours: "Ore di inattività per inviare il report",
        emailReportTimeoutHelp: "Tempo senza risposta del cliente prima di inviare il report.",
        emailReportSubjectTemplate: "Oggetto dell'email",
        emailReportSubjectPlaceholder: "{wlName} - Report ticket - {contactName}",
        emailReportHtmlTemplate: "Template HTML dell'email",
        emailReportHtmlHelp: "Puoi modificare il modello. Viene precaricato il modello attuale del sistema.",
        emailReportVarsTitle: "Variabili disponibili in oggetto e template",
        emailReportVarsDesc: "{wlName} brand · {companyName} azienda · {contactName} nome contatto · {contactPhone} telefono · {queueName} coda · {userName} operatore · {ticketId} · {closeReason} motivo · {aiSummary} riepilogo IA · {ticketLink} link · {closedAt} data · {wlLogoUrl} logo",
        emailReportTestLabel: "Email per invio di prova",
        emailReportTestBtn: "Invia prova",
        emailReportTestSending: "Invio in corso...",
        emailReportTestSuccess: "✓ Email di prova inviata a {email}",
        emailReportTestError: "✗ Errore: {error}",
        emailReportSuperadminAllowed: "Consenti report via email",
        emailReportSuperadminAllowedHelp: "Abilita la sezione di configurazione dei report email per l'admin dell'azienda.",
      },
      headerMetrics: {
        resueltos: "Chat chiusi oggi dal tuo team",
        atencionEspera: "Chat in gestione attiva / in attesa di risposta ora",
        tdr1ra: "Tempo medio dal primo messaggio del cliente alla prima risposta dell'operatore oggi",
        tdrResp: "Tempo medio di risposta per messaggio negli ultimi 30 giorni",
      },
      appointmentsSettings: {
        titulo: "Configurazione Appuntamenti",
        empresa: "Azienda",
        general: "Generale",
        activarModulo: "Attiva modulo appuntamenti",
        contactarAdmin: "Per attivare o disattivare il modulo appuntamenti, contatta l'amministratore di sistema.",
        canalWhatsapp: "Canale WhatsApp per gli avvisi",
        principalAuto: "Principale (automatico)",
        tiposCita: "Tipi di appuntamento",
        tiposCitaDesc: "Il consulente sceglie il tipo al momento della prenotazione. Sii specifico.",
        cargarEjemplos: "Carica esempi",
        nuevoTipo: "Nuovo tipo",
        agregar: "Aggiungi",
        avisosAutomaticos: "Avvisi automatici",
        aviso1: "Avviso 1 — 24 ore prima",
        aviso2: "Avviso 2 — A inizio giornata dell'appuntamento",
        aviso3: "Avviso 3 — Poco prima dell'appuntamento",
        textoMensaje: "Testo del messaggio",
        minutosAntes: "Minuti prima",
        horaAviso: "Ora dell'avviso",
        notaAviso2: "Nota: Se l'appuntamento è a prima mattina e l'avviso 3 cade entro i 30 minuti successivi, questo avviso viene omesso automaticamente.",
        guardarConfig: "Salva configurazione",
        errorGuardar: "Errore nel salvataggio",
        configGuardada: "Configurazione salvata",
      },
      bulkSend: {
        steps: { upload: "File", preview: "Anteprima", template: "Modello", options: "Opzioni", confirm: "Conferma" },
        history: {
          title: "Cronologia invii",
          viewHistory: "Vedi cronologia invii",
          backToWizard: "Torna alla procedura guidata",
          backToList: "Torna alla cronologia",
          columnDate: "Data", columnFile: "File", columnStatus: "Stato", columnProgress: "Avanzamento",
          loadMore: "Carica altri", empty: "Non è ancora stato effettuato nessun invio.",
        },
        back: "Indietro",
        next: "Avanti",
        upload: {
          hint: "Trascina o clicca per caricare il tuo file Excel (.xlsx)",
          choose: "Scegli file",
          selected: "File: {{name}}",
          readError: "Impossibile leggere il file",
        },
        preview: {
          total: "Righe totali", valid: "Valide", skipped: "Scartate",
          skFilter: "Per filtro", skPhone: "Telefono non valido", skDup: "Duplicate",
          sample: "Campione (prime righe normalizzate)",
          colName: "Nome", colPhone: "Telefono", colVars: "Variabili",
          noValid: "Non ci sono righe valide da inviare. Controlla il file e i filtri del profilo.",
        },
        template: {
          connLabel: "Connessione Meta", noConn: "Nessuna connessione Meta collegata in questa azienda.",
          tplLabel: "Modello approvato", noTpl: "Questa connessione non ha modelli approvati.",
          lastUsedHint: "ultimo usato",
          varsTitle: "Anteprima del messaggio (con la prima riga)",
          varMismatch: "Il modello ha {{tpl}} variabili ma il profilo ne genera {{prof}}. Scegli un modello con lo stesso numero.",
        },
        options: {
          throttle: "Secondi tra gli invii", throttleHelp: "Pausa tra ogni messaggio (da 1 a 60 secondi).",
          contextModeLabel: "Modalità di contesto",
          contextModeNormal: "Normale",
          contextModeTurnosia: "TurnosIA (invito a prenotare)",
          contextModeHint: "Come viene comunicato all'assistente di cosa tratta questo invio. In modalità TurnosIA, oltre a inviare il modello, si indica all'assistente che il contatto è stato invitato a prenotare un appuntamento.",
          optIn: "Confermo che i destinatari hanno dato il consenso a ricevere messaggi.",
          overwriteTitle: "Attenzione: questo invio sovrascrive dati esistenti",
          overwrite: "Se un destinatario esiste già come contatto in WAIA, questo invio sovrascriverà le sue note e riassegnerà l'assistente, la coda e lo stato definiti in questo profilo. Conferma che questo comportamento è quello desiderato.",
        },
        confirm: {
          title: "Controlla prima di inviare", file: "File", validRows: "Righe da inviare",
          conn: "Connessione", tpl: "Modello", throttle: "Pausa tra gli invii",
          warnBrief: "Ricorda: i contatti esistenti vengono sovrascritti (note, assistente, coda, stato).",
          send: "Conferma e invia", sentOk: "Invio avviato",
        },
        dedupe: {
          msg: "È già stato caricato un file identico il {{date}}. Inviare comunque?",
          confirm: "Invia comunque", cancel: "Annulla",
        },
        result: {
          title: "Risultato dell'invio", pending: "In coda", processing: "In elaborazione",
          completed: "Completato", pausedMeta: "In pausa (Meta)", failed: "Fallito", cancelled: "Annullato",
          sent: "Inviati", failedC: "Falliti", skipped: "Scartati", total: "Totale",
          pausedExplain: "L'invio è stato messo in pausa perché Meta ha rifiutato 5 messaggi consecutivi. Controlla la connessione e riprova quelli falliti.",
          retry: "Riprova falliti", retrying: "Nuovo tentativo...", retryDone: "{{n}} righe rimesse in coda",
          newImport: "Nuovo invio", rowsTitle: "Dettaglio per riga", colStatus: "Stato", colDetail: "Dettaglio",
          rowStatus: {
            pending: "In coda", sent: "Inviato", failed: "Fallito",
            skipped_filter: "Scartata (filtro)", skipped_invalid_phone: "Telefono non valido",
            skipped_dup_in_batch: "Duplicata", skipped_optout: "Senza consenso",
          },
        },
      },
      cargaDeDatos: {
        menuTitle: "Caricamento Dati",
        empty: "Nessun modulo configurato",
        loading: "Caricamento in corso...",
        errorLoading: "Errore nel caricamento del modulo",
      },
      metaTemplates: {
        drawerTitle: "Template Meta",
        tabMine: "I miei template",
        tabSend: "Invia template",
        syncButton: "Sincronizza",
        syncSuccess: "{{count}} template sincronizzati",
        syncError: "Errore durante la sincronizzazione",
        newButton: "Nuovo template",
        noTemplates: "Nessun template. Clicca Sincronizza per caricare da Meta.",
        deleteConfirm: "Eliminare questo template in Meta e nel sistema?",
        deleteSuccess: "Template eliminato",
        deleteError: "Errore nell'eliminazione del template",
        createSuccess: "Template inviato a Meta per approvazione",
        createError: "Errore nella creazione del template",
        sendSuccess: "Template inviato",
        sendError: "Errore nell'invio del template",
        form: {
          name: "Nome (snake_case, senza spazi)",
          category: "Categoria",
          language: "Lingua",
          headerType: "Intestazione (opzionale)",
          headerFormat: "Tipo di intestazione",
          headerFormats: {
            NONE: "Nessuna",
            TEXT: "Testo",
            IMAGE: "Immagine",
            DOCUMENT: "Documento",
            VIDEO: "Video",
          },
          headerSample: "File di esempio",
          headerSampleNotice:
            "Questo file è solo un esempio perché Meta approvi il modello. A ogni invio sceglierai il file reale (la fattura, il preventivo, ecc.).",
          headerSampleChoose: "Scegli file di esempio",
          pendingNotice:
            "Il modello resta in attesa finché Meta non lo approva. L'approvazione può richiedere tempo; lo stato si aggiorna sincronizzando.",
          headerText: "Testo dell'intestazione",
          body: "Corpo del messaggio",
          bodyHint: "Usa {{1}}, {{2}}, ecc. per le variabili",
          examplesHint: "Meta richiede un esempio per ogni variabile per approvare il template.",
          exampleFor: "Esempio per {{var}}",
          varsNotSequential: "Le variabili devono essere consecutive da {{1}} (senza salti).",
          footer: "Footer (opzionale)",
          submit: "Crea template",
          cancel: "Annulla",
        },
        suggested: {
          useButton: "Usa un modello suggerito",
          listTitle: "Modelli suggeriti (pronti per l'approvazione)",
          approvalNotice:
            "Questi modelli passano per l'approvazione di Meta, ma essendo pre-validati di solito vengono approvati in fretta. Puoi modificare testo ed esempi prima di crearlo.",
          names: {
            retomar_conversacion: "Riprendi conversazione",
            recordatorio_cita: "Promemoria appuntamento",
            seguimiento_general: "Follow-up",
            aviso_disponible: "Avviso novità",
            reapertura_24h: "Riapertura dopo 24h",
          },
        },
        categories: {
          MARKETING: "Marketing",
          UTILITY: "Utilità",
          AUTHENTICATION: "Autenticazione",
        },
        languages: {
          es: "Spagnolo",
          en: "Inglese",
          pt: "Portoghese",
          it: "Italiano",
        },
        status: {
          APPROVED: "Approvato",
          PENDING: "In attesa",
          REJECTED: "Rifiutato",
          PAUSED: "In pausa",
          DELETED: "Eliminato",
          DISABLED: "Disabilitato",
          IN_APPEAL: "In appello",
          REINSTATED: "Ripristinato",
          LIMIT_EXCEEDED: "Limite superato",
          PENDING_DELETION: "In attesa di eliminazione",
        },
        sendForm: {
          attachment: "Allegato",
          attachmentChoose: "Scegli file",
          attachmentHint: {
            DOCUMENT: "Questo modello invia un documento: scegli il file reale (PDF, Word o Excel).",
            IMAGE: "Questo modello invia un'immagine: scegli il file reale.",
            VIDEO: "Questo modello invia un video: scegli il file reale.",
          },
          selectTemplate: "Seleziona un template approvato",
          toNumber: "Numero di destinazione (con prefisso paese)",
          variables: "Variabile {{index}}",
          submit: "Invia",
          noApproved: "Nessun template approvato",
        },
        windowBanner: {
          message: "⏰ Finestra 24h chiusa. Il contatto deve scrivere prima, oppure avvia la conversazione con un template.",
          sendTemplate: "Invia template",
        },
        inline: {
          selectLabel: "Scegli un template",
          noApproved: "Non hai ancora template approvati. Creane uno per iniziare la conversazione.",
          createButton: "Crea template",
          previewLabel: "Anteprima",
          sendButton: "Invia template",
          sentTitle: "Template inviato",
          sendAnother: "Invia un altro",
        },
      },
      embeddedSignup: {
        title: "Collega WhatsApp Business",
        connectButton: "Connetti con Meta",
        manualButton: "Inserisci dati manualmente",
        connecting: "Connessione in corso...",
        success: "Connessione creata con successo",
        error: "Errore durante la connessione con Meta",
        connectionName: "Nome della connessione",
        emptyMetaError: "Completa la connessione con Meta (pulsante Connetti con Meta) o inserisci i dati manualmente. Non è possibile creare una connessione Meta vuota.",
        cancelled: "Connessione con Meta annullata.",
      },
      batchSelection: {
        exit: "Esci dalla selezione",
        count: "{{count}} selezionati",
        markRead: "Segna come letto",
        resolve: "Risolvi",
        transfer: "Trasferisci",
        delete: "Elimina",
        restore: "Ripristina",
        hardDelete: "Elimina definitivamente",
        more: "Altre azioni",
        selectAllVisible: "Seleziona tutti i visibili",
        toast: {
          markReadOk: "{{count}} chat segnate come lette",
          markReadPartial: "Segnate come lette {{processed}} di {{total}} ({{skipped}} saltate)",
          resolveOk: "{{count}} chat risolte",
          resolvePartial: "Risolte {{processed}} di {{total}} ({{skipped}} saltate)",
          transferOk: "{{count}} chat trasferite",
          transferPartial: "Trasferite {{processed}} di {{total}} ({{skipped}} saltate)",
          restoreOk: "{{count}} chat ripristinate",
          restorePartial: "Ripristinate {{processed}} di {{total}} ({{skipped}} saltate)",
          deletedWithUndo: "{{count}} chat spostate in Eliminati",
          undo: "Annulla",
          undoOk: "Ripristino applicato",
          hardDeleteOk: "{{count}} chat eliminate definitivamente",
          hardDeletePartial: "Eliminate definitivamente {{processed}} di {{total}} ({{skipped}} saltate)",
        },
      },
      resolveTicketDialog: {
        title: "Com'è andata questa conversazione?",
        batchCount: "Risolverai {{count}} chat.",
        won: "Vinta",
        lost: "Persa",
        noChange: "Nessuna modifica — risolvi comunque",
      },
      batchTransferDialog: {
        title: "Trasferisci chat",
        subtitle: "Trasferirai {{count}} chat a un reparto.",
        queueLabel: "Reparto destinazione",
        queuePlaceholder: "Seleziona reparto...",
        cancel: "Annulla",
        confirm: "Trasferisci",
      },
      batchDeleteDialog: {
        title: "Elimina chat",
        body: "Stai per eliminare {{count}} chat. Puoi ripristinarle da Eliminati.",
        cancel: "Annulla",
        confirm: "Elimina",
      },
      batchHardDeleteDialog: {
        title: "Elimina definitivamente",
        body: "Questo eliminerà {{count}} chat in modo permanente. Non è possibile annullare.",
        bodySingle: "Questo eliminerà questa chat in modo permanente. Non è possibile annullare.",
        cancel: "Annulla",
        confirm: "Elimina definitivamente",
      },
      quotedMessage: {
        sticker: "Sticker",
        image: "Immagine",
        video: "Video",
        audio: "Messaggio vocale",
        document: "Documento",
        vcard: "Contatto",
        location: "Posizione",
        attachment: "Allegato",
      },
      mediaPlaceholder: {
        sticker: "Sticker",
        image: "Immagine",
        video: "Video",
        audio: "Messaggio vocale",
        document: "Documento",
        attachment: "Allegato",
      },
      documentPreview: {
        download: "Scarica",
        openInNew: "Apri in una nuova scheda",
        previewFailed: "Impossibile caricare l'anteprima",
      },
      ticketPresence: {
        composing: "Sta scrivendo...",
        recording: "Sta registrando audio...",
        composingNamed: "{{name}} sta scrivendo...",
        recordingNamed: "{{name}} sta registrando audio...",
        composingSomeone: "Qualcuno sta scrivendo...",
        recordingSomeone: "Qualcuno sta registrando audio...",
      },
      ticketAttending: {
        header: "In gestione da {{name}}",
        // feat_340: sin uso — el zócalo ahora muestra solo el primer nombre del asesor.
        chip: "Gestisce {{name}}",
        locked: "In gestione da {{name}} — non puoi scrivere",
        someone: "un altro operatore",
      },
      cartAbandonedSchedule: {
        modeLabel: "Quando inviare l'avviso di carrello abbandonato?",
        always: "Sempre (senza limiti di orario)",
        businessHours: "Solo durante l'orario di lavoro dell'azienda",
        custom: "Orario personalizzato per i carrelli",
        helperAlways: "L'avviso viene inviato in qualsiasi momento in cui si rileva inattività.",
        helperBusinessHours: "Se l'azienda è fuori orario quando viene rilevato l'abbandono, l'avviso viene automaticamente rinviato alla prossima esecuzione durante l'orario di lavoro.",
        helperCustom: "Definisci un orario proprio per gli avvisi di carrello abbandonato, indipendente dall'orario di lavoro.",
        customScheduleLabel: "Orario personalizzato per gli avvisi di carrello abbandonato",
        warningNoBusinessHours: "⚠ Non hai configurato l'orario di lavoro. L'avviso di carrello abbandonato non verrà inviato finché non lo configuri nella sezione Orario di lavoro.",
        goToBusinessHours: "Vai a Orario di lavoro",
      },
      holidays: {
        title: "Festività",
        nationals: "Festività nazionali",
        nationalsHelp: "Attiva l'interruttore se la tua azienda lavora in quel giorno festivo.",
        customs: "Festività proprie",
        noCustoms: "Nessuna festività propria.",
        works: "Lavoriamo",
        closed: "Chiuso",
        recurring: "ogni anno",
        addCustom: "Aggiungi festività",
        confirmDelete: "Eliminare questa festività?",
        dateLabel: "Data",
        nameLabel: "Nome",
        recurringLabel: "Si ripete ogni anno",
        recurringHelp: "",
        cancel: "Annulla",
        save: "Salva",
        saveOk: "Festività salvata",
      },
      weeklySchedule: {
        addRange: "Aggiungi fascia",
        removeRange: "Rimuovi fascia",
        to: "alle",
        days: {
          monday: "Lunedì",
          tuesday: "Martedì",
          wednesday: "Mercoledì",
          thursday: "Giovedì",
          friday: "Venerdì",
          saturday: "Sabato",
          sunday: "Domenica",
        },
      },
      emailReportTimerMode: {
        label: "Da quando contare il tempo per il report?",
        updatedAt: "Dall'ultimo messaggio inviato o ricevuto",
        updatedAtHelp: "Il contatore si azzera ogni volta che c'è un nuovo messaggio nel ticket, incluse le risposte automatiche dell'IA.",
        createdAt: "Dall'inizio della conversazione (T0)",
        createdAtHelp: "Il contatore non si azzera con l'attività automatica. L'email arriva sempre a {{hours}}h dal primo messaggio, indipendentemente dal tentativo di recupero dell'IA.",
      },
      metaErrorCodes: {
        "-100": "Non inviato: gli invii di questa connessione erano in pausa.",
        tooltipPrefix: "Consegna non riuscita",
        131042: "Manca il metodo di pagamento in Meta (Centro fatturazione).",
        131047: "Finestra di 24 ore chiusa — è richiesto un modello approvato.",
        131026: "Il numero non ha WhatsApp o il messaggio non è stato recapitato.",
        131051: "Tipo di messaggio non supportato da Meta.",
        132000: "Il modello non corrisponde alle variabili inviate.",
        132001: "Il modello non esiste o è stato eliminato.",
        132005: "Il modello è in pausa da parte di Meta.",
        132007: "Il modello è stato disabilitato da Meta.",
        132012: "Formato variabile del modello non valido.",
        133010: "Il numero non è registrato su WhatsApp Cloud API.",
        default: "Errore di consegna Meta (codice {{code}}).",
        default_unknown: "Errore di consegna Meta.",
      },
      // feat_299 — "Visualizza come utente". Namespace proprio: NON riusare
      // `impersonate` (pannello superadmin), è un'altra cosa.
      viewAs: {
        menuLabel: "Visualizza come utente",
        modalTitle: "Visualizza come utente",
        searchPlaceholder: "Cerca utente...",
        cancel: "Annulla",
        noUsers: "Nessun utente disponibile",
        banner: "Visualizzi come {{name}}",
        exit: "Esci",
        activated: "Ora visualizzi come {{name}}",
      },
      // feat_316 — preferenze di notifica per utente
      notificationPrefs: {
        title: "Notifiche",
        active: "Attive",
        mutedPermanent: "Silenziate",
        snoozedUntil: "Silenziate fino alle {{time}}",
        snoozeFor: "Silenzia per:",
        untilOpening: "Fino all'apertura",
        mutePermanent: "Silenzia finché non le riattivo",
        sound: "Suono",
        browser: "Notifica del browser",
        browserBlocked: "Il browser ha bloccato le notifiche. Abilitale dal lucchetto nella barra degli indirizzi.",
        browserDenied: "Permesso non concesso. Puoi abilitarlo dal lucchetto nella barra degli indirizzi.",
        badgeNote: "Il silenziamento riguarda il suono e l'avviso del browser. Il contatore e l'elenco delle chat continuano ad aggiornarsi.",
      },
      contactPriority: {
        label: "Priorità di notifica",
        normal: "Normale",
        priority: "Prioritario (notifica sempre)",
        muted: "Silenziato (non notifica mai)",
        help: "\"Prioritario\" notifica anche con le notifiche silenziate. \"Silenziato\" non notifica mai.",
      },
      // feat_333 — modalità WAIAenvios (etichetta dello switch nel pannello superadmin)
      waiaEnvios: {
        switchLabel: "WAIAenvios — solo invii con modello",
        switchHelp: "Lascia il pannello con solo Connessioni e Caricamento Dati. Il cliente risponde dal proprio telefono.",
      },
      // Boundary di modulo (feat_364). Se TurnosIA si rompe, si rompe SOLO TurnosIA.
      errorBoundary: {
        routeTitle: "Questa schermata non è stata mostrata",
        routeHelp: "Prova un'altra sezione del menu, oppure ricarica la pagina.",
        moduleTitle: "Questa sezione non è disponibile in questo momento",
        moduleHelp: "Il resto di WAIA continua a funzionare normalmente. Se succede di nuovo, avvisa l'assistenza.",
        appTitle: "Qualcosa non ha funzionato",
        appHelp: "Ricarica la pagina per continuare.",
        inline: "Non è stato possibile mostrare questa parte.",
        retry: "Riprova",
        reload: "Ricarica la pagina",
      },
    },
  },
};

export { messages };
